(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[28,958],{

/***/ "+wNj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutPropertiesLoose; });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ "8K1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inherits; });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("XcBm");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(subClass, superClass);
}

/***/ }),

/***/ "9fIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _classCallCheck; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "C9cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createPropsForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRentalAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getServiceAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getServiceAgesLabelTranslateOptions; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");



var IS_DISABLED = 'isDisabled';
var IS_ENABLED = 'isEnabled';
var IS_SELECTED = 'isSelected';

var getServiceAgesLabel = function getServiceAgesLabel(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    });
  }

  if (min < 23 && max && max > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    });
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  });
};

function getServiceAgesLabelTranslateOptions(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return ['booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    }];
  }

  if (min < 23 && max && max > 23) {
    return ['booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    }];
  }

  return ['booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  }];
}

var getRentalAgesLabel = function getRentalAgesLabel(ageInMonths) {
  if (!ageInMonths || !ageInMonths.min) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.forAllAges');
  }

  if (ageInMonths.max) {
    return getServiceAgesLabel(ageInMonths);
  }

  if (ageInMonths.min < 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.ageFromMonths', {
      amount: ageInMonths.min
    });
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.ageFrom', {
    age: Math.floor(ageInMonths.min / 12)
  });
};

var createPropsForPictures = function createPropsForPictures(images) {
  if (!Array.isArray(images)) {
    return [];
  }

  return images.map(function (link) {
    return {
      src: link
    };
  });
};

var createPropsForProduct = function createPropsForProduct(resort) {
  var _resort$destination;

  return {
    id: resort.id,
    header: {
      className: 'border-r-1',
      heading: {
        subtitle: resort === null || resort === void 0 ? void 0 : (_resort$destination = resort.destination) === null || _resort$destination === void 0 ? void 0 : _resort$destination.country,
        title: resort.name || ''
      },
      link: {
        url: resort.href
      },
      productId: resort.id,
      productType: resort.type
    },
    thumbnail: {
      link: {
        url: resort.href
      },
      pictures: createPropsForPictures(resort.images),
      productId: resort.id,
      productType: resort.type
    },
    url: resort.href,
    type: resort.type || ''
  };
};



/***/ }),

/***/ "DQFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSlideShow; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("u/u4");
/* harmony import */ var _arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Gy6l");
/* harmony import */ var _backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("NZxu");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("0IQ5");
/* harmony import */ var _slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("A5Hi");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;








var ImageSlideShow = function ImageSlideShow(_ref) {
  var centerPadding = _ref.centerPadding,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      fadeUnseenItems = _ref.fadeUnseenItems,
      galleryLabel = _ref.galleryLabel,
      _ref$groupKey = _ref.groupKey,
      groupKey = _ref$groupKey === void 0 ? 'thumbnails' : _ref$groupKey,
      hasFullScreenMode = _ref.hasFullScreenMode,
      hasOverlappingControls = _ref.hasOverlappingControls,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      hasLazyLoading = _ref.hasLazyLoading,
      itemClassName = _ref.itemClassName,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      _ref$nbItemsToShow = _ref.nbItemsToShow,
      nbItemsToShow = _ref$nbItemsToShow === void 0 ? 1 : _ref$nbItemsToShow,
      nextLabel = _ref.nextLabel,
      onChangeIndex = _ref.onChangeIndex,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__[/* default */ "c"].XL : _ref$ratio,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 : _ref$ratioDisplay,
      _ref$spacerWidth = _ref.spacerWidth,
      spacerWidth = _ref$spacerWidth === void 0 ? 0 : _ref$spacerWidth;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(false),
      isFullScreen = _useState[0],
      setIsFullScreen = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(0),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  if (!media.length) {
    return null;
  }

  var updateActiveIndex = function updateActiveIndex(index) {
    setActiveIndex(index);
  };

  var gk = hasFullScreenMode ? null : groupKey;
  var items = media.filter(function (_ref2) {
    var src = _ref2.src;
    return Boolean(src);
  }).map(function (_ref3) {
    var _ref3$alt = _ref3.alt,
        alt = _ref3$alt === void 0 ? '' : _ref3$alt,
        _onClick = _ref3.onClick,
        src = _ref3.src;

    var children = __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_8__[/* default */ "b"], {
      altMsg: alt,
      className: itemClassName,
      groupKey: gk,
      hasLazyLoading: hasLazyLoading,
      imageUrl: src,
      key: src,
      ratioKey: ratio,
      ratioDisplay: ratioDisplay,
      spacerWidth: ratioDisplay
    });

    var isButton = hasFullScreenMode || _onClick;
    return __jsx(react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], {
      key: "Image-".concat(src)
    }, isButton ? __jsx("button", {
      className: "block h-full w-full",
      onClick: function onClick() {
        _onClick && _onClick();

        if (hasFullScreenMode) {
          setIsFullScreen(true);
        }
      },
      type: "button"
    }, children) : __jsx("div", {
      className: "h-full"
    }, children));
  });
  return __jsx(_slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_9__[/* SliderHandler */ "a"], {
    centerPadding: centerPadding,
    fadeUnseenItems: fadeUnseenItems,
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items,
    nbItemsToShow: nbItemsToShow,
    onChangeIndex: updateActiveIndex,
    spacerWidth: spacerWidth
  }, function (_ref4) {
    var hasControls = _ref4.hasControls,
        isNextControlDisabled = _ref4.isNextControlDisabled,
        isPreviousControlDisabled = _ref4.isPreviousControlDisabled,
        itemsNode = _ref4.itemsNode,
        onNext = _ref4.onNext,
        onPrevious = _ref4.onPrevious;
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, 'group relative')
    }, itemsNode, hasControls && __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('transition-opacity duration-250 ease-in will-change-transform absolute flex items-center justify-between m-auto inset-0 pointer-events-none w-full z-2', {
        'px-10 sm:px-20': !hasOverlappingControls
      }),
      "data-testid": "ImageSlideShow-controls-parent"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('me-auto pointer-events-auto shadow-sm z-2', {
        'transform -translate-x-1/2': hasOverlappingControls
      }),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('ms-auto pointer-events-auto shadow-sm z-2', {
        'transform translate-x-1/2': hasOverlappingControls
      }),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })), hasFullScreenMode && isFullScreen && __jsx(_backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_7__[/* Backdrop */ "a"], {
      ariaLabel: galleryLabel,
      closeLabel: closeLabel,
      hasCloseButton: true,
      onClose: function onClose() {
        return setIsFullScreen(false);
      }
    }, __jsx("div", {
      className: "relative w-full"
    }, itemsNode, hasControls && __jsx("div", {
      className: "absolute flex items-center justify-between m-auto inset-0 pointer-events-none px-10 sm:px-20 w-full"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: "me-auto pointer-events-auto shadow-sm z-2",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: "ms-auto pointer-events-auto shadow-sm z-2",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })))));
  });
};

/***/ }),

/***/ "ELg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductFlag_ProductFlag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 5 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx + 1 modules
var ProductPriceModal = __webpack_require__("yfdt");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.themes.js
var themes = {
  thumbnail: {
    thPriceTheme: 'inline'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx



var __jsx = react_default.a.createElement;









var ProductFlag_ProductFlag = function ProductFlag(_ref) {
  var _ref$isLinkDisabled = _ref.isLinkDisabled,
      isLinkDisabled = _ref$isLinkDisabled === void 0 ? false : _ref$isLinkDisabled,
      _ref$isPriceLoading = _ref.isPriceLoading,
      isPriceLoading = _ref$isPriceLoading === void 0 ? false : _ref$isPriceLoading,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop_default.a : _ref$onClick,
      _ref$onCtaClick = _ref.onCtaClick,
      onCtaClick = _ref$onCtaClick === void 0 ? noop_default.a : _ref$onCtaClick,
      _ref$onEmptyPriceClic = _ref.onEmptyPriceClick,
      onEmptyPriceClick = _ref$onEmptyPriceClic === void 0 ? noop_default.a : _ref$onEmptyPriceClic,
      _ref$onIconBubbleClic = _ref.onIconBubbleClick,
      onIconBubbleClick = _ref$onIconBubbleClic === void 0 ? noop_default.a : _ref$onIconBubbleClic,
      _ref$onPriceClick = _ref.onPriceClick,
      onPriceClick = _ref$onPriceClick === void 0 ? noop_default.a : _ref$onPriceClick,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? {} : _ref$price,
      _ref$priceInfo = _ref.priceInfo,
      priceInfo = _ref$priceInfo === void 0 ? {} : _ref$priceInfo,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'thumbnail' : _ref$theme;

  if (isEmpty_default()(price)) {
    return null;
  }

  var thPriceTheme = themes[theme].thPriceTheme;
  var hasPrice = !isPriceLoading && Object(price_util["d" /* hasAtLeastOnePrice */])(price);

  var handleEmptyPriceClick = function handleEmptyPriceClick() {
    onEmptyPriceClick && onEmptyPriceClick();

    if (!isLinkDisabled) {
      onClick && onClick();
    }
  };

  var handlePriceClick = function handlePriceClick() {
    onPriceClick && onPriceClick();
  };

  var handleProductPriceModalOnClickButton = function handleProductPriceModalOnClickButton() {
    onCtaClick && onCtaClick();
    onClick && onClick();
  };

  var priceNode = __jsx("span", {
    className: "flex gap-5"
  }, __jsx("button", {
    className: "flex items-center justify-end w-full",
    onClick: hasPrice ? handlePriceClick : handleEmptyPriceClick,
    type: "button"
  }, __jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({
    color: colors["a" /* COLORS */].SIENNA
  }, price, {
    "data-testid": "Price-wrapper",
    from: price.from,
    hasInitialPrice: true,
    isLoading: isPriceLoading,
    theme: thPriceTheme
  }))), hasPrice && Object(i18n["d" /* getKeyValue */])('price.displayIconBubble') && __jsx("button", {
    className: "mt-5",
    onClick: function onClick() {
      return onIconBubbleClick && onIconBubbleClick();
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].SIENNA,
    name: icons["a" /* ICONS */].INFORMATION,
    width: "1.25rem"
  })));

  return hasPrice ? __jsx(ProductPriceModal["a" /* ProductPriceModal */], Object(esm_extends["a" /* default */])({}, priceInfo, {
    onClickButton: handleProductPriceModalOnClickButton
  }), priceNode) : __jsx("div", {
    className: "m-5"
  }, priceNode);
};

/***/ }),

/***/ "Fe0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export grid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateProductLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateLinkProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return localeHasCmtaLinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateCmtaLinkProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCruiseExclusivity; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("igjW");
/* harmony import */ var _utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("0JpG");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("CcNa");







var grid = {
  mobile: 1,
  phablet: 2,
  tablet: 3,
  desktop: 3
};
var generateProductLink = function generateProductLink(url, offer) {
  var newLink = offer && offer.seoName ? new urijs__WEBPACK_IMPORTED_MODULE_2___default.a(url).addSearch(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["appQueryParameters"].shopping.offer, _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeSlug(offer.seoName)).toString() : url;
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeUrl(newLink);
};
var generateLinkProp = function generateLinkProp(url, offer) {
  return url ? {
    url: generateProductLink(url, offer),
    queryParamsToIgnore: offer ? [] : ['offer']
  } : undefined;
};
var localeHasCmtaLinks = function localeHasCmtaLinks(cmtaLinks) {
  return cmtaLinks && cmtaLinks.cmtaIntegLink && cmtaLinks.cmtaStagingLink && cmtaLinks.cmtaProdLink;
};
var generateCmtaLinkProp = function generateCmtaLinkProp(resortId, cmtaLinks) {
  var cmtaIntegLink = cmtaLinks.cmtaIntegLink,
      cmtaStagingLink = cmtaLinks.cmtaStagingLink,
      cmtaProdLink = cmtaLinks.cmtaProdLink;
  var cmtaUrl = cmtaProdLink;

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__[/* isStrictlyIntegrationEnv */ "e"])()) {
    cmtaUrl = cmtaIntegLink;
  }

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__[/* isStrictlyStagingEnv */ "g"])()) {
    cmtaUrl = cmtaStagingLink;
  }

  return {
    url: cmtaUrl + resortId,
    isExternalLink: true
  };
};
var getCruiseExclusivity = function getCruiseExclusivity() {
  var _data$cruiseExclusivi;

  var productId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _runGQLQuery = Object(_utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_5__[/* useGQL */ "a"])({
    query: "query {\n      cruiseExclusivity(productId: \"".concat(productId, "\") {\n        isExclusive\n      }\n    }"),
    queryOptions: {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* LINE_CRUISE_EXCLUSIVITY */ "Jb"]
    }
  }),
      data = _runGQLQuery.data,
      isCruiseExclusivityLoading = _runGQLQuery.isLoading;

  return {
    isCruiseExclusive: !!(data === null || data === void 0 ? void 0 : (_data$cruiseExclusivi = data.cruiseExclusivity) === null || _data$cruiseExclusivi === void 0 ? void 0 : _data$cruiseExclusivi.isExclusive),
    isCruiseExclusivityLoading: isCruiseExclusivityLoading
  };
};

/***/ }),

/***/ "Gqxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _ResponsiveContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("1JJ2");










var __jsx = react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




function Responsiveness(WrappedComponent) {
  var Responsive = /*#__PURE__*/function (_Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Responsive, _Component);

    var _super = _createSuper(Responsive);

    function Responsive() {
      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, Responsive);

      return _super.apply(this, arguments);
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Responsive, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            ref = _this$props.forwardRef,
            props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_this$props, ["forwardRef"]);

        return __jsx(_ResponsiveContext__WEBPACK_IMPORTED_MODULE_11__[/* ResponsiveContext */ "a"].Consumer, null, function (responsive) {
          return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({
            ref: ref
          }, props, {
            responsive: responsive
          }));
        });
      }
    }]);

    return Responsive;
  }(react__WEBPACK_IMPORTED_MODULE_10__["Component"]);

  return /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_10__["forwardRef"])(function (props, ref) {
    return __jsx(Responsive, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, props, {
      forwardRef: ref
    }));
  });
}

/* harmony default export */ __webpack_exports__["a"] = (Responsiveness);

/***/ }),

/***/ "HbGN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutProperties; });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("+wNj");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),

/***/ "IuYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Price_Price; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.themes.js

var themes = {
  "default": function _default(_ref) {
    var color = _ref.color,
        hasInitialPriceDisplayed = _ref.hasInitialPriceDisplayed;
    return {
      thRoot: 'flex flex-wrap gap-x-10 isolate items-baseline relative text-14',
      thFirstLine: 'flex gap-x-10 items-baseline',
      thFrom: classnames_default()('text-12 first-letter:uppercase', {
        'absolute top-0': hasInitialPriceDisplayed
      }),
      thInitialPrice: "font-semibold line-through text-14 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold text-32',
      thUnit: 'text-12'
    };
  },
  column: function column(_ref2) {
    var color = _ref2.color;
    return {
      thRoot: 'flex flex-col isolate leading-tight relative text-14',
      thFirstLine: 'flex gap-x-10 items-baseline',
      thFrom: 'first-letter:uppercase',
      thInitialPrice: "font-semibold line-through text-14 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold text-32 w-full',
      thUnit: 'text-12'
    };
  },
  inline: function inline(_ref3) {
    var color = _ref3.color;
    return {
      thRoot: 'flex gap-x-5 isolate items-baseline relative text-10 sm:text-12',
      thFirstLine: 'flex gap-x-5 items-baseline shrink-0',
      thFrom: 'first-letter:uppercase',
      thInitialPrice: "font-semibold line-through text-10 sm:text-12 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold shrink-0 text-20 underline',
      thUnit: 'text-10 sm:text-12'
    };
  },
  inlineSmall: function inlineSmall(_ref4) {
    var color = _ref4.color;
    return {
      thRoot: 'flex gap-x-5 isolate items-baseline relative text-10 sm:text-12',
      thFirstLine: 'flex gap-x-5 items-baseline',
      thFrom: 'first-letter:uppercase',
      thInitialPrice: "font-semibold line-through text-10 sm:text-12 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold text-14 sm:text-20',
      thUnit: 'text-10 sm:text-12'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.jsx


var __jsx = react_default.a.createElement;







var PriceDiscount_PriceDiscount = function PriceDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SIENNA : _ref$color,
      from = _ref.from,
      hasAsterisk = _ref.hasAsterisk,
      _ref$hasDiscount = _ref.hasDiscount,
      hasDiscount = _ref$hasDiscount === void 0 ? false : _ref$hasDiscount,
      _ref$hasInitialPrice = _ref.hasInitialPrice,
      hasInitialPrice = _ref$hasInitialPrice === void 0 ? false : _ref$hasInitialPrice,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? true : _ref$hasInstalment,
      _ref$hasTotalPrice = _ref.hasTotalPrice,
      hasTotalPrice = _ref$hasTotalPrice === void 0 ? false : _ref$hasTotalPrice,
      initialPrice = _ref.initialPrice,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      unit = _ref.unit,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["bestPrice", "className", "color", "from", "hasAsterisk", "hasDiscount", "hasInitialPrice", "hasInstalment", "hasTotalPrice", "initialPrice", "theme", "unit"]);

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var initialPriceFormattedValue = hasInstalment && initialPrice ? Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Math.floor(initialPrice.value), locale, initialPrice.currency, {
    precision: 0
  }) : initialPrice && initialPrice.formattedValue;
  var totalBestPrice = bestPrice && bestPrice.formattedValue;
  var bestPriceFormattedValue = hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])(bestPrice, locale) : totalBestPrice;
  var hasInitialPriceDisplayed = hasInitialPrice && initialPriceFormattedValue && (hasDiscount || !bestPrice);
  var hasTotalPriceDisplayed = hasTotalPrice && hasInstalment && bestPriceFormattedValue !== totalBestPrice;

  var _themes$theme = themes[theme]({
    color: color,
    hasInitialPriceDisplayed: hasInitialPriceDisplayed
  }),
      thBestPrice = _themes$theme.thBestPrice,
      thFirstLine = _themes$theme.thFirstLine,
      thFrom = _themes$theme.thFrom,
      thInitialPrice = _themes$theme.thInitialPrice,
      thRoot = _themes$theme.thRoot,
      thTotalPrice = _themes$theme.thTotalPrice,
      thUnit = _themes$theme.thUnit;

  return __jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: classnames_default()(className, thRoot)
  }), (hasInitialPriceDisplayed || hasTotalPriceDisplayed || from) && __jsx("span", {
    className: thFirstLine
  }, from && __jsx("span", {
    className: thFrom
  }, from), hasInitialPriceDisplayed && __jsx("span", {
    className: thInitialPrice,
    "data-testid": "PriceItem-value"
  }, initialPriceFormattedValue), hasTotalPriceDisplayed && __jsx("span", {
    className: thTotalPrice,
    "data-testid": "PriceItem-value"
  }, totalBestPrice)), bestPriceFormattedValue && __jsx("span", {
    className: thBestPrice,
    "data-testid": "PriceItem-value"
  }, bestPriceFormattedValue), unit && __jsx("span", {
    className: thUnit
  }, unit, hasAsterisk && __jsx("sup", null, "*")));
};
// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.themes.js
var PriceViewRate_themes_themes = {
  "default": {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16'
  },
  column: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16'
  },
  inline: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.jsx


var PriceViewRate_jsx = react_default.a.createElement;





var PriceViewRate_PriceViewRate = function PriceViewRate(_ref) {
  var className = _ref.className,
      label = _ref.label,
      theme = _ref.theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "label", "theme"]);

  var _themes$theme = PriceViewRate_themes_themes[theme],
      thIcon = _themes$theme.thIcon,
      thRoot = _themes$theme.thRoot;

  if (!label) {
    return null;
  }

  return PriceViewRate_jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: classnames_default()(className, thRoot)
  }), PriceViewRate_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].DATE,
    width: "1em"
  }), label);
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/prices/Prices.jsx


var Prices_jsx = react_default.a.createElement;






var Prices_PriceLoader = function PriceLoader(_ref) {
  var className = _ref.className;
  return Prices_jsx("span", {
    className: classnames_default()(className, 'loadingDots'),
    "data-testid": "Price-loader"
  });
};

var Prices_Prices = function Prices(_ref2) {
  var bestPrice = _ref2.bestPrice,
      className = _ref2.className,
      color = _ref2.color,
      from = _ref2.from,
      hasAsterisk = _ref2.hasAsterisk,
      hasInitialPrice = _ref2.hasInitialPrice,
      hasInstalment = _ref2.hasInstalment,
      hasTotalPrice = _ref2.hasTotalPrice,
      initialPrice = _ref2.initialPrice,
      isLoading = _ref2.isLoading,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme,
      unit = _ref2.unit,
      viewRates = _ref2.viewRates,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref2, ["bestPrice", "className", "color", "from", "hasAsterisk", "hasInitialPrice", "hasInstalment", "hasTotalPrice", "initialPrice", "isLoading", "theme", "unit", "viewRates"]);

  var displayPrice = Object(price_util["d" /* hasAtLeastOnePrice */])({
    initialPrice: initialPrice,
    bestPrice: bestPrice
  });

  if (isLoading) {
    return Prices_jsx(Prices_PriceLoader, {
      className: className
    });
  }

  if (!displayPrice && !viewRates) {
    return null;
  }

  if (!displayPrice) {
    return Prices_jsx(PriceViewRate_PriceViewRate, Object(esm_extends["a" /* default */])({}, rest, {
      className: className,
      label: viewRates,
      theme: theme
    }));
  }

  return Prices_jsx(PriceDiscount_PriceDiscount, Object(esm_extends["a" /* default */])({}, rest, {
    bestPrice: bestPrice,
    className: className,
    color: color,
    from: from,
    hasAsterisk: hasAsterisk,
    hasDiscount: Object(price_util["e" /* hasDiscount */])({
      bestPrice: bestPrice,
      initialPrice: initialPrice
    }),
    hasInitialPrice: hasInitialPrice,
    hasInstalment: hasInstalment,
    hasTotalPrice: hasTotalPrice,
    initialPrice: initialPrice,
    unit: unit,
    theme: theme
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.jsx



var Price_jsx = react_default.a.createElement;




var INSTALMENT_LOCALES = ['pt-BR', 'es-AR'];
var Price_Price = function Price(_ref) {
  var _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? true : _ref$hasInstalment,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["hasInstalment"]);

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var displayInstalment = hasInstalment && Object(i18n["d" /* getKeyValue */])('common.price.displayInstalmentsPrice') && INSTALMENT_LOCALES.includes(locale);
  return Price_jsx(Prices_Prices, Object(esm_extends["a" /* default */])({}, props, {
    hasInstalment: displayInstalment
  }));
};

/***/ }),

/***/ "K/z8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _possibleConstructorReturn; });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4wDe");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("pWxA");


function _possibleConstructorReturn(self, call) {
  if (call && (Object(_typeof_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(self);
}

/***/ }),

/***/ "LNcM":
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function(window, document) {
'use strict';


// Exits early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}


/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = entry.rootBounds;
  this.boundingClientRect = entry.boundingClientRect;
  this.intersectionRect = entry.intersectionRect || getEmptyRect();
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (options.root && options.root.nodeType != 1) {
    throw new Error('root must be an Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections();
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {

    return item.element != target;
  });
  if (!this._observationTargets.length) {
    this._unmonitorIntersections();
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function() {
  if (!this._monitoringIntersections) {
    this._monitoringIntersections = true;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      this._monitoringInterval = setInterval(
          this._checkForIntersections, this.POLL_INTERVAL);
    }
    else {
      addEvent(window, 'resize', this._checkForIntersections, true);
      addEvent(document, 'scroll', this._checkForIntersections, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
        this._domObserver = new MutationObserver(this._checkForIntersections);
        this._domObserver.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function() {
  if (this._monitoringIntersections) {
    this._monitoringIntersections = false;

    clearInterval(this._monitoringInterval);
    this._monitoringInterval = null;

    removeEvent(window, 'resize', this._checkForIntersections, true);
    removeEvent(document, 'scroll', this._checkForIntersections, true);

    if (this._domObserver) {
      this._domObserver.disconnect();
      this._domObserver = null;
    }
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, rootRect);

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootRect,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, rootRect) {

  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var targetRect = getBoundingClientRect(target);
  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return;

    if (parent == this.root || parent == document) {
      atRoot = true;
      parentRect = rootRect;
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      if (parent != document.body &&
          parent != document.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);

      if (!intersectionRect) break;
    }
    parent = getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {Object} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var html = document.documentElement;
    var body = document.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {Object} rect The rect object to expand.
 * @return {Object} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  return containsDeep(this.root || document, target);
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object} The intersection rect or undefined if no intersection
 *     is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  };
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {Object} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {Object} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}

/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }
  return parent;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}(window, document));


/***/ }),

/***/ "MMYH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createClass; });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("DAgO");

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "N5WC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Tag_Tag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.themes.js



var themes = {
  "default": function _default(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref$color,
        _ref$colorBg = _ref.colorBg,
        colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$colorBg,
        colorBorder = _ref.colorBorder;
    return {
      thRoot: classnames_default()("bg-".concat(colorBg, " border-1 border-").concat(colorBorder || colorBg, " text-").concat(color), 'font-bold font-sans gap-5 inline-flex items-center leading-1 overflow-hidden px-10 py-5 rounded-extra text-12 whitespace-nowrap')
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.jsx


var __jsx = react_default.a.createElement;




var Tag_Tag = function Tag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      colorBg = _ref.colorBg,
      colorBorder = _ref.colorBorder,
      iconName = _ref.iconName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "color", "colorBg", "colorBorder", "iconName", "theme"]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme]({
    color: color,
    colorBg: colorBg,
    colorBorder: colorBorder
  }),
      thRoot = _themes$theme.thRoot;

  return __jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: classnames_default()(className, thRoot)
  }), __jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    color: color,
    name: iconName,
    width: "1em"
  }), children);
};

/***/ }),

/***/ "UXOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ NavTag_NavTag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/nav-tag/NavTag.themes.js




var themes = {
  "default": function _default(_ref) {
    var _classnames;

    var _ref$colorActive = _ref.colorActive,
        colorActive = _ref$colorActive === void 0 ? colors["a" /* COLORS */].LIGHT_SAND : _ref$colorActive,
        _ref$colorUnactive = _ref.colorUnactive,
        colorUnactive = _ref$colorUnactive === void 0 ? colors["a" /* COLORS */].SAND : _ref$colorUnactive,
        isActive = _ref.isActive;
    return {
      thRoot: classnames_default()('block border font-bold items-stretch px-20 py-10 rounded-extra text-12 text-black text-sans transition-colors duration-250 ease-in whitespace-nowrap', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "bg-".concat(colorActive, " border-").concat(colorActive), isActive), Object(defineProperty["a" /* default */])(_classnames, "bg-transparent border-".concat(colorUnactive, " hocus:bg-").concat(colorActive, " hocus:border-").concat(colorActive), !isActive), _classnames))
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/nav-tag/NavTag.jsx




var __jsx = react_default.a.createElement;




var NavTag_NavTag = function NavTag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      colorActive = _ref.colorActive,
      colorUnactive = _ref.colorUnactive,
      href = _ref.href,
      isActive = _ref.isActive,
      _onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$trackingData = _ref.trackingData,
      trackingData = _ref$trackingData === void 0 ? {} : _ref$trackingData,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "colorActive", "colorUnactive", "href", "isActive", "onClick", "theme", "trackingData"]);

  var tracker = Object(useTracking["a" /* useTracking */])();
  var track = !isEmpty_default()(trackingData) && _onClick ? function () {
    return tracker(trackingData);
  } : noop_default.a;

  if (!react["Children"].count(children)) {
    return null;
  }

  var TagName = 'div';

  if (href) {
    TagName = 'a';
  } else if (_onClick) {
    TagName = 'button';
  }

  var _themes$theme = themes[theme]({
    colorActive: colorActive,
    colorUnactive: colorUnactive,
    isActive: isActive
  }),
      thRoot = _themes$theme.thRoot;

  return __jsx(TagName, Object(esm_extends["a" /* default */])({
    "data-testid": "Tag" // $FlowFixMe

  }, rest, {
    className: classnames_default()(className, thRoot),
    onClick: function onClick(e) {
      _onClick && _onClick(e);
      track();
    },
    href: href
  }, _onClick ? {
    type: href ? 'link' : 'button'
  } : null), children);
};

/***/ }),

/***/ "XTOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_Product; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__("S0cN");
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.utils.js
var Product_utils = __webpack_require__("Fe0B");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/tag/Tag.jsx + 1 modules
var Tag = __webpack_require__("N5WC");

// CONCATENATED MODULE: ./src/client/components/widgets/offer-discount/OfferDiscount.jsx
var __jsx = react_default.a.createElement;



var OfferDiscount_OfferDiscount = function OfferDiscount(_ref) {
  var _discount$amount;

  var className = _ref.className,
      discount = _ref.discount,
      i18n = _ref.i18n;
  var offerName = (discount === null || discount === void 0 ? void 0 : discount.offerName) || (i18n === null || i18n === void 0 ? void 0 : i18n.defaultLabel) || '';
  var backgroundColor = (discount === null || discount === void 0 ? void 0 : discount.offerColor) || (i18n === null || i18n === void 0 ? void 0 : i18n.defaultColor) || null;
  return (discount === null || discount === void 0 ? void 0 : (_discount$amount = discount.amount) === null || _discount$amount === void 0 ? void 0 : _discount$amount.value) ? __jsx(Tag["a" /* Tag */], {
    className: className,
    color: colors["a" /* COLORS */].WHITE,
    style: {
      backgroundColor: backgroundColor
    }
  }, offerName) : null;
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-header/ProductHeader.jsx
var ProductHeader = __webpack_require__("hgS3");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-comparison/ProductComparison.jsx

var ProductComparison_jsx = react_default.a.createElement;





var ProductComparison_ProductComparison = function ProductComparison(_ref) {
  var className = _ref.className,
      eligibilityLabel = _ref.eligibilityLabel,
      isEligible = _ref.isEligible,
      label = _ref.label,
      onComparisonClick = _ref.onComparisonClick,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? product_utils["b" /* IS_ENABLED */] : _ref$status;

  if (!isEligible) {
    return ProductComparison_jsx("div", {
      className: "absolute bg-white/60 flex font-bold inset-0 items-center justify-center p-20 rounded-12 text-14 text-center z-1"
    }, eligibilityLabel);
  }

  var isSelectable = status !== product_utils["a" /* IS_DISABLED */];
  var isSelected = status === product_utils["c" /* IS_SELECTED */];
  var buttonProps = isSelectable ? {
    onClick: onComparisonClick,
    type: 'button',
    title: label
  } : null;
  var TagName = isSelectable ? 'button' : 'div';
  return ProductComparison_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()(className, 'absolute bg-darkGrey/40 flex h-full inset-0 items-center justify-center p-20 rounded-12 text-white w-full z-1')
  }, buttonProps), isSelectable && ProductComparison_jsx("span", {
    className: classnames_default()('aspect-square border-2 leading-0 p-10 rounded-full transition-colors duration-250 ease-in', {
      'bg-transparent border-white': !isSelected,
      'bg-saffron border-saffron text-black': isSelected
    })
  }, ProductComparison_jsx(Icon["a" /* Icon */], {
    name: isSelected ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].PLUS,
    width: "1.25rem"
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx + 1 modules
var ProductFlag = __webpack_require__("ELg1");

// EXTERNAL MODULE: ./src/client/components/widgets/product/product-thumbnail/ProductThumbnail.jsx
var ProductThumbnail = __webpack_require__("Z+2E");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/Availability.jsx
var Availability_jsx = react_default.a.createElement;




var computeAvailabilityStatus = function computeAvailabilityStatus(_ref) {
  var availability = _ref.availability,
      remainingStock = _ref.remainingStock;

  switch (true) {
    case availability === 'UNAVAILABLE':
    case availability === 'AVAILABLE' && remainingStock === 0:
      return 'unavailable';

    case availability === 'AVAILABLE' && remainingStock !== null && +remainingStock < 10:
    case availability === 'PARTIAL':
      return 'remaining';

    case availability === 'AVAILABLE':
      return 'available';

    default:
      return 'unknown';
  }
};

var Availability_Availability = function Availability(_ref2) {
  var availability = _ref2.availability,
      config = _ref2.config,
      remainingStock = _ref2.remainingStock;
  var availabilityStatus = computeAvailabilityStatus({
    availability: availability,
    remainingStock: remainingStock
  });

  var _ref3 = config[availabilityStatus] || {},
      color = _ref3.color,
      icon = _ref3.icon,
      label = _ref3.label;

  return label ? Availability_jsx("span", {
    className: "flex flex-none shrink gap-5 items-center text-".concat(color, " text-end")
  }, icon && Availability_jsx(Icon["a" /* Icon */], {
    name: icon,
    width: "0.8rem"
  }), Object(dist["messageFormat"])(label).format({
    count: remainingStock
  })) : null;
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/AvailabilityAge.jsx
var AvailabilityAge_jsx = react_default.a.createElement;



var shouldShowAgeInMonth = function shouldShowAgeInMonth(ageInNumberOfMonths) {
  return ageInNumberOfMonths <= 23;
};

var shouldShowAgeInYearsRange = function shouldShowAgeInYearsRange(ageMin, ageMax) {
  return !(Math.floor(ageMin / 12) === Math.floor(ageMax / 12));
};

var AvailabilityAge_AvailabilityAge = function AvailabilityAge(_ref) {
  var ageMax = _ref.ageMax,
      ageMin = _ref.ageMin,
      childcareLabel = _ref.childcareLabel,
      monthsLabel = _ref.monthsLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var message = '';

  if (shouldShowAgeInMonth(ageMax)) {
    message = Object(dist["messageFormat"])(monthsLabel).format({
      min: ageMin,
      max: ageMax
    });
  } else if (shouldShowAgeInYearsRange(ageMin, ageMax)) {
    message = Object(dist["messageFormat"])(yearsLabel).format({
      min: Math.floor(ageMin / 12),
      max: Math.floor(ageMax / 12)
    });
  } else {
    // Shows a single year age
    message = Object(dist["messageFormat"])(yearLabel).format({
      fixed: Math.floor(ageMin / 12)
    });
  }

  return AvailabilityAge_jsx(react["Fragment"], null, "".concat(childcareLabel, " "), AvailabilityAge_jsx("span", {
    className: "font-normal whitespace-nowrap"
  }, "(", message, ")"));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/productChildcareAvailabilities.jsx

var productChildcareAvailabilities_jsx = react_default.a.createElement;







var productChildcareAvailabilities_ProductChildcareAvailabilities = function ProductChildcareAvailabilities(_ref) {
  var availableLabel = _ref.availableLabel,
      childcareLabel = _ref.childcareLabel,
      items = _ref.items,
      monthsLabel = _ref.monthsLabel,
      remainingLabel = _ref.remainingLabel,
      unavailableLabel = _ref.unavailableLabel,
      unknownLabel = _ref.unknownLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var renderConfig = {
    available: {
      color: colors["a" /* COLORS */].GREEN,
      icon: icons["a" /* ICONS */].CHECK,
      label: availableLabel
    },
    remaining: {
      color: colors["a" /* COLORS */].ORANGE,
      icon: icons["a" /* ICONS */].WARNING,
      label: remainingLabel
    },
    unavailable: {
      color: colors["a" /* COLORS */].RED,
      icon: icons["a" /* ICONS */].CROSS,
      label: unavailableLabel
    },
    unknown: {
      color: colors["a" /* COLORS */].MEDIUM_GREY,
      label: unknownLabel
    }
  };
  return productChildcareAvailabilities_jsx(react["Fragment"], null, items.map(function (_ref2) {
    var ageMax = _ref2.ageMax,
        ageMin = _ref2.ageMin,
        availability = _ref2.availability,
        id = _ref2.id,
        isIncluded = _ref2.isIncluded,
        remainingStock = _ref2.remainingStock;
    return productChildcareAvailabilities_jsx("p", {
      key: id,
      className: "flex font-bold items-start justify-between mt-10 text-14 text-black"
    }, productChildcareAvailabilities_jsx("span", {
      className: "flex-1"
    }, productChildcareAvailabilities_jsx(AvailabilityAge_AvailabilityAge, {
      ageMax: ageMax,
      ageMin: ageMin,
      childcareLabel: childcareLabel,
      monthsLabel: monthsLabel,
      yearLabel: yearLabel,
      yearsLabel: yearsLabel
    }), productChildcareAvailabilities_jsx("span", {
      className: classnames_default()('font-brand font-normal me-5 text-12', {
        'text-black': isIncluded,
        'text-sienna': !isIncluded
      })
    }, isIncluded ? Object(src_i18n["h" /* t */])('common.included') : Object(src_i18n["h" /* t */])('common.onDemand'))), productChildcareAvailabilities_jsx(Availability_Availability, {
      availability: availability,
      config: renderConfig,
      remainingStock: remainingStock
    }));
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.jsx
















var Product_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
























var Product_Product = function Product(_ref) {
  var _flag$price, _flag$price$bestPrice, _flag$price2, _flag$price2$bestPric, _minAuthorizedAge$val;

  var childcare = _ref.childcare,
      childcareIncluded = _ref.childcareIncluded,
      className = _ref.className,
      _ref$cmtaLinks = _ref.cmtaLinks,
      cmtaLinks = _ref$cmtaLinks === void 0 ? {} : _ref$cmtaLinks,
      comfort = _ref.comfort,
      comparison = _ref.comparison,
      departureDateOn = _ref.departureDateOn,
      _ref$flag = _ref.flag,
      flag = _ref$flag === void 0 ? {} : _ref$flag,
      hasComparison = _ref.hasComparison,
      hasDiscount = _ref.hasDiscount,
      _ref$hasFadeIn = _ref.hasFadeIn,
      hasFadeIn = _ref$hasFadeIn === void 0 ? true : _ref$hasFadeIn,
      hasLazyLoading = _ref.hasLazyLoading,
      header = _ref.header,
      id = _ref.id,
      index = _ref.index,
      _ref$isCompact = _ref.isCompact,
      isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
      isLinkDisabled = _ref.isLinkDisabled,
      _ref$kids = _ref.kids,
      kids = _ref$kids === void 0 ? [] : _ref$kids,
      lineName = _ref.lineName,
      _ref$minAuthorizedAge = _ref.minAuthorizedAge,
      minAuthorizedAge = _ref$minAuthorizedAge === void 0 ? {} : _ref$minAuthorizedAge,
      offer = _ref.offer,
      offerDiscount = _ref.offerDiscount,
      onClick = _ref.onClick,
      onComparisonClick = _ref.onComparisonClick,
      ratioDisplay = _ref.ratioDisplay,
      thumbnail = _ref.thumbnail,
      url = _ref.url;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isGsa = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('isGsa');
  var router = Object(next_router["useRouter"])();

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 2),
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var track = Object(useTracking["a" /* useTracking */])({});
  var pageContext = Object(PageContext["b" /* usePageContext */])();
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';
  var clickThumbnailTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: id,
    resortCode: id,
    resortTrident: typeof comfort === 'number' ? comfort : '',
    thumbnailPrice: (flag === null || flag === void 0 ? void 0 : (_flag$price = flag.price) === null || _flag$price === void 0 ? void 0 : (_flag$price$bestPrice = _flag$price.bestPrice) === null || _flag$price$bestPrice === void 0 ? void 0 : _flag$price$bestPrice.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(camelCase_default()(lineName)) : siteSection,
    thumbnailPosition: index + 1
  } : null;
  var clickIconBubbleTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: "".concat(id, "_infoIcon"),
    resortCode: id,
    thumbnailPrice: (flag === null || flag === void 0 ? void 0 : (_flag$price2 = flag.price) === null || _flag$price2 === void 0 ? void 0 : (_flag$price2$bestPric = _flag$price2.bestPrice) === null || _flag$price2$bestPric === void 0 ? void 0 : _flag$price2$bestPric.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(camelCase_default()(lineName)) : siteSection,
    thumbnailPosition: index + 1,
    siteSection: siteSection
  } : null;
  var linkShouldBeDisabled = isLinkDisabled || hasComparison || isGsa;

  var goOnResort = function goOnResort() {
    var newHistoryState = new DynamicLinkUtil["a" /* default */](dist["windowWrapper"].getLocation(), url ? Object(Product_utils["c" /* generateProductLink */])(url, offer) : '');
    router.push(newHistoryState.toString());
  };

  var minAuthorizedAgeMessage = (minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) === 0 ? Object(src_i18n["h" /* t */])('faceting.availabilities.noChildcareFrom0') : Object(src_i18n["h" /* t */])('faceting.availabilities.noChildcare', {
    min_authorized_age_in_months: Math.floor(((_minAuthorizedAge$val = minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) !== null && _minAuthorizedAge$val !== void 0 ? _minAuthorizedAge$val : 0) / 12)
  });
  var childcareBirthdateAlert = (kids === null || kids === void 0 ? void 0 : kids.length) > 0 && childcare && isEmpty_default()(childcare.items) && !childcareIncluded;
  var noChildcareAlert = kids && kids.length > 0 && kids.some(function (kid) {
    return !kid.birthdate;
  }) && childcareIncluded;
  return Product_jsx("article", {
    className: classnames_default()(className, 'isolate relative', {
      fadeInLong: hasFadeIn
    }),
    onClick: onClick
  }, Product_jsx("div", {
    className: classnames_default()('isolate relative', {
      'flex gap-10': isCompact
    })
  }, Product_jsx("div", {
    className: classnames_default()('relative', {
      'w-1/2 shrink-0': isCompact
    }),
    "data-testid": "Product-Header-Wrapper"
  }, hasComparison && Product_jsx(ProductComparison_ProductComparison, Object(esm_extends["a" /* default */])({}, comparison, {
    onComparisonClick: onComparisonClick
  })), !!departureDateOn && Product_jsx(Tag["a" /* Tag */], {
    className: "absolute start-0 mx-10 -translate-y-1/2 z-2",
    color: colors["a" /* COLORS */].SIENNA,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].SIENNA,
    "data-testid": "Product-departure"
  }, departureDateOn), hasDiscount && Product_jsx(OfferDiscount_OfferDiscount, {
    className: "absolute end-0 mx-10 -translate-y-1/2 z-2",
    discount: offerDiscount === null || offerDiscount === void 0 ? void 0 : offerDiscount.discount,
    i18n: offerDiscount === null || offerDiscount === void 0 ? void 0 : offerDiscount.i18n
  }), Product_jsx(ProductThumbnail["a" /* ProductThumbnail */], Object(esm_extends["a" /* default */])({}, thumbnail, {
    className: "overflow-hidden rounded-12",
    hasLazyLoading: hasLazyLoading,
    isLinkDisabled: true,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    ratioDisplay: ratioDisplay
  }))), Product_jsx(ProductHeader["a" /* ProductHeader */], Object(esm_extends["a" /* default */])({}, header, {
    className: classnames_default()({
      'overflow-hidden': isCompact,
      'mt-10': !isCompact
    }),
    isLinkDisabled: linkShouldBeDisabled,
    link: appContext.isCmta && id && Object(Product_utils["e" /* localeHasCmtaLinks */])(cmtaLinks) ? Object(Product_utils["a" /* generateCmtaLinkProp */])(id, cmtaLinks) : Object(Product_utils["b" /* generateLinkProp */])(url, offer),
    onClick: function onClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    }
  }))), !isEmpty_default()(flag) && Product_jsx(ProductFlag["a" /* ProductFlag */], Object(esm_extends["a" /* default */])({}, flag, {
    isLinkDisabled: linkShouldBeDisabled,
    onClick: goOnResort,
    onCtaClick: function onCtaClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_discoverResort")
        }));
      }
    },
    onEmptyPriceClick: function onEmptyPriceClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    },
    onPriceClick: function onPriceClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_bestPrice")
        }));
      }
    },
    onIconBubbleClick: function onIconBubbleClick() {
      if (Object(src_i18n["d" /* getKeyValue */])('price.displayIconBubble')) {
        track(_objectSpread(_objectSpread({}, clickIconBubbleTrackingData), {}, {
          labelGA: "".concat(id, "_infoIcon")
        }));
      }
    },
    price: flag.price
  })), childcareBirthdateAlert && Product_jsx("div", {
    className: "border-1 border-lightGrey flex gap-5 mt-5 p-10 rounded-12 text-12"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "mt-1 shrink-0",
    color: colors["a" /* COLORS */].RED,
    name: icons["a" /* ICONS */].WARNING,
    width: "1rem"
  }), minAuthorizedAgeMessage), noChildcareAlert && Product_jsx("button", {
    className: "bg-sand hocus:bg-sand-active cursor-pointer flex font-bold gap-5 leading-1 mt-5 p-10 rounded-12 text-12 text-initial text-black transition-colors duration-250 ease-in",
    onClick: function onClick() {
      dispatchCriteriaDisplayContext({
        type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
        payload: 'criteriaWho'
      });
      Object(scrollToElement["a" /* scrollToElement */])('[data-testid="CriteriaWho"]', 600);
    },
    type: "button"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "mt-1 shrink-0",
    name: icons["a" /* ICONS */].KIDS,
    width: "1rem"
  }), Object(src_i18n["h" /* t */])('faceting.availabilities.enterBirthdate')), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('faceting.childcare') && childcare && !isEmpty_default()(childcare.items) && Product_jsx(productChildcareAvailabilities_ProductChildcareAvailabilities, childcare));
};

/***/ }),

/***/ "XcBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "Z+2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductThumbnail; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cxan");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("u/u4");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_image_slideshow_ImageSlideShow__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("DQFb");
/* harmony import */ var _frameworks_tag_Tag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("N5WC");



var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;








var OPENING_STATUS = _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["constants"].OPENING_STATUS;
var ProductThumbnail = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_4__["memo"])(function ProductThumbnail(_ref) {
  var _ref$bottomTags = _ref.bottomTags,
      bottomTags = _ref$bottomTags === void 0 ? [] : _ref$bottomTags,
      className = _ref.className,
      closedLabel = _ref.closedLabel,
      hasLazyLoading = _ref.hasLazyLoading,
      isLinkDisabled = _ref.isLinkDisabled,
      isSliderDisabled = _ref.isSliderDisabled,
      _ref$isTagsDisabled = _ref.isTagsDisabled,
      isTagsDisabled = _ref$isTagsDisabled === void 0 ? false : _ref$isTagsDisabled,
      link = _ref.link,
      nextLabel = _ref.nextLabel,
      openingStatus = _ref.openingStatus,
      _ref$pictures = _ref.pictures,
      pictures = _ref$pictures === void 0 ? [] : _ref$pictures,
      previousLabel = _ref.previousLabel,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 / 3 : _ref$ratioDisplay,
      _ref$topTags = _ref.topTags,
      topTags = _ref$topTags === void 0 ? [] : _ref$topTags;
  var TagName = isLinkDisabled ? 'div' : _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"];
  var defaultPicture = pictures[0] || {};
  return __jsx(TagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('block relative', className)
  }, isLinkDisabled ? null : link), !isSliderDisabled && pictures.length > 1 && openingStatus !== OPENING_STATUS.CLOSED ? __jsx(_frameworks_image_slideshow_ImageSlideShow__WEBPACK_IMPORTED_MODULE_9__[/* ImageSlideShow */ "a"], {
    hasLazyLoading: true,
    itemClassName: "isolate overflow-hidden rounded-12 will-change-transform",
    media: pictures,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "c"].XL,
    ratioDisplay: ratioDisplay
  }) : __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_8__[/* Image */ "a"], {
    altMsg: defaultPicture.alt,
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    groupKey: "thumbnails",
    ratioKey: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "c"].XL,
    ratioDisplay: ratioDisplay,
    hasLazyLoading: hasLazyLoading
  }), !!(topTags === null || topTags === void 0 ? void 0 : topTags.length) && !isTagsDisabled && __jsx("div", {
    className: "absolute flex gap-5 justify-end p-10 top-0 w-full",
    "data-testid": "ProductThumbnail-topTags"
  }, topTags.map(function (tag) {
    return __jsx(_frameworks_tag_Tag__WEBPACK_IMPORTED_MODULE_10__[/* Tag */ "a"], {
      color: tag.color,
      colorBg: tag.colorBg,
      iconName: tag.iconName,
      "data-testid": tag.dataTestId,
      key: tag.dataTestId || tag.label,
      style: tag.style
    }, tag.label);
  })), openingStatus === OPENING_STATUS.CLOSED && __jsx("div", {
    className: "absolute bg-black/60 font-bold inline-flex items-center justify-center overflow-hidden inset-0 rounded-12 text-20 text-white uppercase z-1",
    "data-testid": "ProductThumbnail-closed"
  }, closedLabel), !!(bottomTags === null || bottomTags === void 0 ? void 0 : bottomTags.length) && !isTagsDisabled && __jsx("div", {
    className: "absolute bottom-0 flex gap-5 justify-start p-10 w-full",
    "data-testid": "ProductThumbnail-bottomTags"
  }, bottomTags.map(function (tag) {
    return __jsx(_frameworks_tag_Tag__WEBPACK_IMPORTED_MODULE_10__[/* Tag */ "a"], {
      color: tag.color,
      colorBg: tag.colorBg,
      iconName: tag.iconName,
      "data-testid": tag.dataTestId,
      key: tag.dataTestId,
      style: tag.style
    }, tag.label);
  })));
});

/***/ }),

/***/ "aPQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendErrorToSentry; });
/* unused harmony export shouldIgnore */
/* unused harmony export processError */
/* unused harmony export handleBrowserError */
/* unused harmony export handlePromiseError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleComponentError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return start; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("wNDy");













var sanitize = function sanitize() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return s && s.trim().toLowerCase();
};

var sendErrorToSentry = function sendErrorToSentry(_ref) {
  var error = _ref.error,
      _ref$errorInfo = _ref.errorInfo,
      errorInfo = _ref$errorInfo === void 0 ? {} : _ref$errorInfo;

  if ( true && _config__WEBPACK_IMPORTED_MODULE_9___default.a.get('clientError.sentry.enabled')) {
    var _window$Sentry;

    (_window$Sentry = window.Sentry) === null || _window$Sentry === void 0 ? void 0 : _window$Sentry.withScope(function (scope) {
      var _window$Sentry2;

      Object.keys(errorInfo).forEach(function (key) {
        scope.setExtra(key, errorInfo[key]);
      });
      (_window$Sentry2 = window.Sentry) === null || _window$Sentry2 === void 0 ? void 0 : _window$Sentry2.captureException(error);
    });
  }
};
var shouldIgnore = function shouldIgnore(error) {
  var errorMessagesToIgnore = [].concat(_config__WEBPACK_IMPORTED_MODULE_9___default.a.get('clientError.ignore.descriptions'));
  var errorMessage = sanitize(error.message);
  var errorStack = sanitize(error.stack);
  return errorMessagesToIgnore.some(function (messageToIgnore) {
    var msg = sanitize(messageToIgnore);
    var isIgnored = !!msg && (!!errorMessage.includes(msg) || !!errorStack.includes(msg));
    return isIgnored;
  });
};
var processError = function processError(_ref2) {
  var error = _ref2.error,
      errorInfo = _ref2.errorInfo;
  _logger__WEBPACK_IMPORTED_MODULE_10___default.a.error({
    err: error,
    info: errorInfo
  });

  if (!shouldIgnore(error)) {
    sendErrorToSentry({
      error: error,
      errorInfo: errorInfo
    });
  }

  return error;
}; // eslint-disable-next-line max-params

var handleBrowserError = function handleBrowserError(message, file, line, col, error) {
  return processError({
    error: error || new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown error name',
      message: message || 'Unknown error message',
      stack: 'Unknown stack'
    }),
    errorInfo: {
      message: message,
      file: file,
      line: line,
      col: col
    }
  });
};
var handlePromiseError = function handlePromiseError(domCustomEvent) {
  return processError({
    error: lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(domCustomEvent, 'detail.reason', lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(domCustomEvent, 'reason', new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown rejected promise name',
      message: 'Unknown rejected promise message',
      stack: ['Unknown stack']
    })))
  });
};
var handleComponentError = function handleComponentError(error, errorInfo) {
  return processError({
    error: error || new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown component error name',
      message: 'Unknown component error message',
      stack: ['Unknown stack']
    }),
    errorInfo: errorInfo
  });
};
var start = function start() {
  window.onerror = handleBrowserError;
  window.addEventListener('unhandledrejection', handlePromiseError);
  window.addEventListener('rejectionhandled', handlePromiseError);
};

/***/ }),

/***/ "cVnM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Scrollable_Scrollable; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/memoize.js
var memoize = __webpack_require__("pFSi");
var memoize_default = /*#__PURE__*/__webpack_require__.n(memoize);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/feature-testing/index.js + 1 modules
var feature_testing = __webpack_require__("qlAI");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/scrollable/Scrollable.themes.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(defineProperty["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var getNavPositionClasses = function getNavPositionClasses(navPosition) {
  switch (navPosition) {
    case 'top':
      return {
        thRoot: 'flex flex-col',
        thControlsWrapper: 'flex gap-10 justify-end mb-5 order-first w-full',
        thControls: 'flex gap-5 self-center',
        thControl: ''
      };

    case 'side':
      return {
        thRoot: 'flex flex-row justify-between',
        thInner: 'flex-1',
        thControlsWrapper: 'flex gap-10',
        thControls: 'flex gap-5 items-center justify-between pointer-events-none',
        thControl: 'mx-5',
        thControlDisabled: 'sr-only focus:not-sr-only',
        thControlLeft: 'pointer-events-auto mr-auto',
        thControlRight: 'pointer-events-auto ml-auto'
      };

    case 'center':
    default:
      return {
        thRoot: 'overflow-hidden relative',
        thControls: 'absolute flex items-center justify-between inset-0 pointer-events-none w-full z-1',
        thControl: 'mx-5',
        thControlDisabled: 'sr-only focus:not-sr-only',
        thControlLeft: 'pointer-events-auto mr-auto',
        thControlRight: 'pointer-events-auto ml-auto'
      };
  }
};

var themes = {
  "default": function _default(_ref) {
    var navPosition = _ref.navPosition;
    return _objectSpread(_objectSpread({}, getNavPositionClasses(navPosition)), {}, {
      thControlColor: colors["a" /* COLORS */].TRANSPARENT,
      thContolTheme: 'ghost',
      thControlSize: 23
    });
  },
  calendar: function calendar(_ref2) {
    var navPosition = _ref2.navPosition;
    return _objectSpread(_objectSpread({}, getNavPositionClasses(navPosition)), {}, {
      thInner: 'md:px-50',
      thControlColor: colors["a" /* COLORS */].WHITE,
      thControlSize: 46
    });
  },
  tabs: function tabs(_ref3) {
    var navPosition = _ref3.navPosition;
    return _objectSpread(_objectSpread({}, getNavPositionClasses(navPosition)), {}, {
      thControlColor: colors["a" /* COLORS */].LIGHT_SAND,
      thControlSize: 38
    });
  },
  nav: function nav() {
    return {
      thRoot: 'bg-white isolate overflow-hidden px-50 relative',
      thControls: 'absolute flex inset-0 items-center justify-between pointer-events-none w-full',
      thInner: 'border-lightGrey border-l-1 border-r-1',
      thControl: 'text-16',
      thControlLeft: 'mr-auto pointer-events-auto',
      thControlRight: 'ml-auto pointer-events-auto',
      thControlSize: 50,
      thControlColor: colors["a" /* COLORS */].TRANSPARENT,
      thContolTheme: 'ghost'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx











var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var WHEEL_DELTA_SCROLL_FACTOR = 50;
var CLICK_DELTA_SCROLL_FACTOR = 200;
var MOUSE_DELTA_SCROLL_FACTOR = 50;
var Scrollable_Scrollable = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Scrollable, _Component);

  var _super = _createSuper(Scrollable);

  function Scrollable(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Scrollable);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "scrollAreaNode", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "scrolling", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onMouseWheel", function (e) {
      if (!_this.scrollAreaNode) {
        return;
      } // $FlowFixMe


      var wheelDelta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)); // $FlowFixMe

      _this.scrollAreaNode.scrollLeft -= wheelDelta * _this.props.deltaScrollFactorWheel; // Prevent page to scroll down

      if (_this.state.hasScrollLeft || _this.state.hasScrollRight) {
        e.preventDefault();
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onScroll", function () {
      var state = _this.processScroll();

      _this.setState(state);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "isIE11", memoize_default()(function () {
      return !!window.MSInputMethodContext && !!document.documentMode;
    }));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onMouseDown", function (direction) {
      return function () {
        if (!_this.scrollAreaNode) {
          return;
        }

        _this.scrolling = setInterval(function () {
          if (!_this.scrollAreaNode) {
            return;
          } // $FlowFixMe


          _this.scrollAreaNode.scrollLeft += // $FlowFixMe
          _this.props.deltaScrollFactorMouse * _this.getNormalizedDirection(direction);

          _this.onScroll();

          if (direction === -1 && !_this.state.hasScrollLeft || direction === 1 && !_this.state.hasScrollRight) {
            clearInterval(_this.scrolling);
          }
        }, 100);
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onMouseUp", function () {
      clearInterval(_this.scrolling);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClick", function (direction) {
      return function () {
        if (!_this.scrollAreaNode) {
          return;
        } // $FlowFixMe


        _this.scrollAreaNode.scrollLeft += // $FlowFixMe
        _this.props.deltaScrollFactorClick * _this.getNormalizedDirection(direction);

        _this.onScroll();
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setScrollAreaRef", function (ref) {
      _this.scrollAreaNode = ref;
    });

    _this.state = {
      hasScrollLeft: false,
      hasScrollRight: false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(Scrollable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.scrollAreaNode) {
        return;
      }

      if (this.props.hasNoMouseWheelScroll) {
        this.onScroll();
        return;
      }

      if (true) {
        // $FlowFixMe
        this.scrollAreaNode.addEventListener('scroll', this.onScroll, false); // $FlowFixMe

        this.scrollAreaNode.addEventListener('mousewheel', this.onMouseWheel, false); // $FlowFixMe

        this.scrollAreaNode.addEventListener('DOMMouseScroll', this.onMouseWheel, false); // Firefox

        this.onScroll();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.initialPosition !== this.props.initialPosition) {
        this.initScrollPosition();
      }

      var _this$processScroll = this.processScroll(),
          hasScrollLeft = _this$processScroll.hasScrollLeft,
          hasScrollRight = _this$processScroll.hasScrollRight;

      if (prevState.hasScrollRight !== hasScrollRight || prevState.hasScrollLeft !== hasScrollLeft) {
        this.setState({
          hasScrollLeft: hasScrollLeft,
          hasScrollRight: hasScrollRight
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.scrollAreaNode || this.props.hasNoMouseWheelScroll) {
        return;
      }

      if (true) {
        // $FlowFixMe
        this.scrollAreaNode.removeEventListener('scroll', this.onScroll, false); // $FlowFixMe

        this.scrollAreaNode.removeEventListener('mousewheel', this.onMouseWheel, false); // $FlowFixMe

        this.scrollAreaNode.removeEventListener('DOMMouseScroll', this.onMouseWheel, false);
      }
    }
    /**
     * Sometimes IE 11 cannot get the right scrollWidth
     * It returns scrollWidth + 1
     */

  }, {
    key: "shouldFixBrowser",
    value: function shouldFixBrowser(isIE11) {
      if (isIE11) {
        // $FlowFixMe
        var _this$scrollAreaNode = this.scrollAreaNode,
            clientWidth = _this$scrollAreaNode.clientWidth,
            scrollWidth = _this$scrollAreaNode.scrollWidth; // $FlowFixMe

        var boundingClientRectWidth = Math.round(this.scrollAreaNode.getBoundingClientRect().width);
        var diff = scrollWidth - clientWidth;
        return scrollWidth > clientWidth && boundingClientRectWidth === clientWidth && diff === 1;
      }

      return false;
    }
  }, {
    key: "initScrollPosition",
    value: function initScrollPosition() {
      if (!this.scrollAreaNode) {
        return;
      }

      if (this.props.elementWidth && this.props.initialPosition) {
        var normalizedPosition = !this.isIE11() && this.context.isRTL ? // $FlowFixMe
        -1 * this.props.initialPosition : this.props.initialPosition; // $FlowFixMe

        this.scrollAreaNode.scrollLeft = this.props.elementWidth * normalizedPosition;
      }
    }
  }, {
    key: "processScroll",
    value: function processScroll() {
      if (!this.scrollAreaNode) {
        return {
          hasScrollLeft: false,
          hasScrollRight: false
        };
      }

      var _this$scrollAreaNode2 = this.scrollAreaNode,
          scrollLeft = _this$scrollAreaNode2.scrollLeft,
          clientWidth = _this$scrollAreaNode2.clientWidth,
          scrollWidth = _this$scrollAreaNode2.scrollWidth; // $FlowFixMe

      var isRTL = document.documentElement.dir === 'rtl';
      var isIE11 = this.isIE11();
      var browserFix = this.shouldFixBrowser(isIE11) ? 1 : 0;
      var hasScrollRight = isRTL && !isIE11 ? scrollLeft < 0 : scrollLeft + clientWidth < scrollWidth - browserFix; // the minus 1 is here to handle scroll correctly, I don't know where it came this pixel

      var hasScrollLeft = isRTL && !isIE11 ? scrollLeft > -(scrollWidth - clientWidth - 1) : scrollLeft > 0;
      return {
        hasScrollLeft: isIE11 && isRTL ? hasScrollRight : hasScrollLeft,
        hasScrollRight: isIE11 && isRTL ? hasScrollLeft : hasScrollRight
      };
    }
  }, {
    key: "getNormalizedDirection",
    value: function getNormalizedDirection(direction) {
      return this.isIE11() && this.context.isRTL ? -1 * direction : direction;
    }
  }, {
    key: "shouldDisplayControls",
    value: function shouldDisplayControls() {
      var _this$state = this.state,
          hasScrollLeft = _this$state.hasScrollLeft,
          hasScrollRight = _this$state.hasScrollRight;
      var hasControlsOnTouch = this.props.hasControlsOnTouch;
      return (hasControlsOnTouch || !Object(feature_testing["a" /* hasTouch */])()) && (hasScrollLeft || hasScrollRight);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          backwardLabel = _this$props.backwardLabel,
          children = _this$props.children,
          childrenWrapperClassNames = _this$props.childrenWrapperClassNames,
          className = _this$props.className,
          controlsClassName = _this$props.controlsClassName,
          forceDisplayControls = _this$props.forceDisplayControls,
          forwardLabel = _this$props.forwardLabel,
          hasShadow = _this$props.hasShadow,
          header = _this$props.header,
          innerClassName = _this$props.innerClassName,
          navPosition = _this$props.navPosition,
          theme = _this$props.theme;

      if (!react["Children"].count(children)) {
        return null;
      }

      var _this$state2 = this.state,
          hasScrollLeft = _this$state2.hasScrollLeft,
          hasScrollRight = _this$state2.hasScrollRight;
      var isRTL = this.context.isRTL;

      var _themes$theme = themes[theme]({
        navPosition: navPosition
      }),
          thControl = _themes$theme.thControl,
          thControlColor = _themes$theme.thControlColor,
          thControlDisabled = _themes$theme.thControlDisabled,
          thControlLeft = _themes$theme.thControlLeft,
          thControlRight = _themes$theme.thControlRight,
          thControlSize = _themes$theme.thControlSize,
          thContolTheme = _themes$theme.thContolTheme,
          thControls = _themes$theme.thControls,
          thControlsWrapper = _themes$theme.thControlsWrapper,
          thInner = _themes$theme.thInner,
          thRoot = _themes$theme.thRoot;

      var hasControls = this.shouldDisplayControls() || forceDisplayControls;

      var rightScrollBtn = __jsx(ArrowButton["a" /* ArrowButton */], {
        className: classnames_default()(thControl, thControlRight, Object(defineProperty["a" /* default */])({}, thControlDisabled, !hasScrollRight)),
        color: thControlColor,
        hasNoRtl: true,
        isDisabled: !hasScrollRight,
        key: "right",
        label: forwardLabel,
        onClick: this.onClick(1),
        onMouseDown: this.onMouseDown(1),
        onMouseUp: this.onMouseUp,
        rotation: 180,
        size: thControlSize,
        theme: thContolTheme
      });

      var leftScrollBtn = __jsx(ArrowButton["a" /* ArrowButton */], {
        className: classnames_default()(thControl, thControlLeft, Object(defineProperty["a" /* default */])({}, thControlDisabled, !hasScrollLeft)),
        color: thControlColor,
        hasNoRtl: true,
        isDisabled: !hasScrollLeft,
        key: "left",
        label: backwardLabel,
        onClick: this.onClick(-1),
        onMouseDown: this.onMouseDown(-1),
        onMouseUp: this.onMouseUp,
        size: thControlSize,
        theme: thContolTheme
      });

      var scrollButtons = isRTL ? [rightScrollBtn, leftScrollBtn] : [leftScrollBtn, rightScrollBtn];
      return __jsx("div", {
        className: classnames_default()(className, thRoot),
        "data-testid": "scrollable"
      }, __jsx("div", {
        className: classnames_default()('overflow-hidden relative', innerClassName, thInner, {
          'shadow-inner-left': hasShadow && hasScrollLeft,
          'shadow-inner-right': hasShadow && hasScrollRight
        })
      }, __jsx("div", {
        className: classnames_default()(childrenWrapperClassNames, 'scroll-x-area overflow-y-hidden tap-highlight-color-transparent'),
        ref: this.setScrollAreaRef
      }, children)), (hasControls || !!header) && __jsx("div", {
        className: thControlsWrapper
      }, header, hasControls && __jsx("div", {
        className: classnames_default()(controlsClassName, thControls),
        "data-testid": "Scrollable-controls"
      }, scrollButtons)));
    }
  }]);

  return Scrollable;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Scrollable_Scrollable, "contextType", ResponsiveContext["a" /* ResponsiveContext */]);

Object(defineProperty["a" /* default */])(Scrollable_Scrollable, "defaultProps", {
  children: null,
  deltaScrollFactorClick: CLICK_DELTA_SCROLL_FACTOR,
  deltaScrollFactorMouse: MOUSE_DELTA_SCROLL_FACTOR,
  deltaScrollFactorWheel: WHEEL_DELTA_SCROLL_FACTOR,
  elementWidth: 82,
  forceDisplayControls: false,
  hasControlsOnTouch: false,
  hasNoMouseWheelScroll: false,
  hasShadow: false,
  initialPosition: null,
  navPosition: 'center',
  theme: 'default'
});

/***/ }),

/***/ "hgS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductHeader; });
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MWZw");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;




var ProductHeader = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_2__["memo"])(function ProductHeader(_ref) {
  var className = _ref.className,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? {} : _ref$heading,
      isLinkDisabled = _ref.isLinkDisabled,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {
    url: ''
  } : _ref$link,
      onClick = _ref.onClick;
  var _heading$title = heading.title,
      title = _heading$title === void 0 ? '' : _heading$title,
      _heading$subtitle = heading.subtitle,
      subtitle = _heading$subtitle === void 0 ? '' : _heading$subtitle;
  return __jsx("header", {
    className: className,
    "data-testid": "Product-Header"
  }, __jsx(_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({
    className: "flex flex-col-reverse min-w-0",
    "data-testid": "ProductHeader-link",
    onClick: onClick,
    tagname: "div",
    url: isLinkDisabled ? '' : link.url
  }, isLinkDisabled ? null : link), !isLinkDisabled && __jsx("div", {
    className: "absolute inset-0",
    "data-testid": "ProductHeader-link-overlay"
  }), __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_5__[/* Title */ "a"], {
    className: "flex font-sans font-semibold text-18",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BLACK,
    hasEllipsis: true,
    hLevel: 2,
    theme: "none"
  }, title), __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_5__[/* Title */ "a"], {
    className: "flex font-sans font-semibold text-14",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].SIENNA,
    hasEllipsis: true,
    hLevel: 3,
    theme: "none"
  }, subtitle)));
});

/***/ }),

/***/ "igjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isStrictlyProductionEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isStrictlyStagingEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isStrictlyIntegrationEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isStrictlyTestEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isStrictlyDevelopmentEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentLocale; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_2__);



function getCurrentUri(req) {
  return new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(decodeURI(req.originalUrl)).protocol(req.protocol).host(req.get('host'));
}
function isProduction() {
  return _config__WEBPACK_IMPORTED_MODULE_2___default.a.get('DEPLOYMENT_ENV') === 'production';
}
function isStrictlyProductionEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && (cfg.get('DEPLOYMENT_ENV') === 'production' || cfg.get('DEPLOYMENT_ENV') === 'prod');
}
function isStrictlyStagingEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'staging';
}
function isStrictlyIntegrationEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'integration';
}
function isStrictlyTestEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'test';
}
function isStrictlyDevelopmentEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'development' || cfg.get('NODE_ENV') === 'dev';
}
function getCurrentLocale(requestedLocale, hostname) {
  if (requestedLocale) {
    return requestedLocale;
  }

  var domainServiceForHostname = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default.a.forHostname(hostname);
  return domainServiceForHostname.getDefaultLocale();
}

/***/ }),

/***/ "iiKe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CheckedList_CheckedList; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/checked-list/CheckedList.themes.js

var themes = {
  "default": {
    thTitle: 'mb-20',
    thList: 'sm:columns-2 -m-5',
    thListItem: 'flex gap-10 p-5',
    thIcon: 'bg-green shrink-0 p-5 rounded-full',
    thIconColor: colors["a" /* COLORS */].WHITE,
    thIconWidth: '1.2em'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/checked-list/CheckedList.jsx

var __jsx = react_default.a.createElement;






var CheckedList_CheckedList = function CheckedList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      itemClassName = _ref.itemClassName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thTitle = _themes$theme.thTitle,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thIcon = _themes$theme.thIcon,
      thIconColor = _themes$theme.thIconColor,
      thIconWidth = _themes$theme.thIconWidth;
  return __jsx(react["Fragment"], null, title && __jsx(Title["a" /* Title */], {
    className: thTitle,
    theme: "title-sans-n3"
  }, title), __jsx("ul", {
    className: classnames_default()(className, thList)
  }, react["Children"].map(children, function (child, idx) {
    return __jsx("li", {
      className: classnames_default()(itemClassName, thListItem),
      key: idx
    }, __jsx(Icon["a" /* Icon */], {
      color: thIconColor,
      className: thIcon,
      name: icons["a" /* ICONS */].CHECK,
      width: thIconWidth
    }), child);
  })));
};

/***/ }),

/***/ "nZ6J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export descriptors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getComponent; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("m9LP");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("hNT8");
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("psNz");







 // const mod = ({ Component }) => Component;

var descriptors = new Map([
/* layout lines */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* PAGE_TRACKING */ "G"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(123)]).then(__webpack_require__.bind(null, "sLNG"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("sLNG")];
    },
    modules: ["./tracking/descriptor"]
  }
})],
/* common lines */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* ALL_INCLUSIVE_PUSH */ "a"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(176)]).then(__webpack_require__.bind(null, "DS8N"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("DS8N")];
    },
    modules: ["./all-inclusive-push/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* BRAND_PROMISE */ "b"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(29), __webpack_require__.e(184)]).then(__webpack_require__.bind(null, "WtX0"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("WtX0")];
    },
    modules: ["./brand-promise/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* BRAND_SUPERIORITY */ "c"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(166)]).then(__webpack_require__.bind(null, "JRrv"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("JRrv")];
    },
    modules: ["./brand-superiority/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* BUTTON_TICKET */ "d"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(198)]).then(__webpack_require__.bind(null, "ISYn"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ISYn")];
    },
    modules: ["./button-ticket/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* CHECKLIST */ "e"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(28), __webpack_require__.e(199)]).then(__webpack_require__.bind(null, "4LJ+"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("4LJ+")];
    },
    modules: ["./checklist/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* COMPARISON_TABLE */ "f"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(142)]).then(__webpack_require__.bind(null, "IjOA"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("IjOA")];
    },
    modules: ["./comparison-table/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* CRISIS_ALERT */ "g"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(173)]).then(__webpack_require__.bind(null, "3c8P"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("3c8P")];
    },
    modules: ["./crisis-alert/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* DESTINATIONS */ "j"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(29), __webpack_require__.e(154)]).then(__webpack_require__.bind(null, "UYKV"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("UYKV")];
    },
    modules: ["./destinations/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* DOWNLOAD_LINKS_LIST */ "k"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(185)]).then(__webpack_require__.bind(null, "yTkl"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("yTkl")];
    },
    modules: ["./download-links-list/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* EDITORIAL_FOLDING_BLOCK */ "l"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(169)]).then(__webpack_require__.bind(null, "ms+y"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ms+y")];
    },
    modules: ["./editorial-folding-block/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* EVENT_ANIMATION */ "m"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(170)]).then(__webpack_require__.bind(null, "ddrH"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ddrH")];
    },
    modules: ["./event-animation/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* EVENT_FORM */ "n"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(138)]).then(__webpack_require__.bind(null, "jvJq"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("jvJq")];
    },
    modules: ["./event-form/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* IMMERSIVE */ "s"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(211)]).then(__webpack_require__.bind(null, "RgPE"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("RgPE")];
    },
    modules: ["./immersive/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* INSPIRATIONAL_GRID */ "t"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(43)]).then(__webpack_require__.bind(null, "3Fn9"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("3Fn9")];
    },
    modules: ["./inspirational-grid/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* LAST_SEEN_PRODUCTS */ "u"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(144)]).then(__webpack_require__.bind(null, "Qdj2"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Qdj2")];
    },
    modules: ["./last-seen-products/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* MEDIA_TEXT_HORIZONTAL */ "v"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(158)]).then(__webpack_require__.bind(null, "xoIU"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("xoIU")];
    },
    modules: ["./media-text-horizontal/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* MEDIA_TEXT_VERTICAL */ "w"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(159)]).then(__webpack_require__.bind(null, "jyQO"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("jyQO")];
    },
    modules: ["./media-text-vertical/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* MEDIA_THUMBNAIL */ "x"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(155)]).then(__webpack_require__.bind(null, "YWPa"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("YWPa")];
    },
    modules: ["./media-thumbnail/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* NAVIGATION_TAB */ "z"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 214).then(__webpack_require__.bind(null, "Q52w"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Q52w")];
    },
    modules: ["./navigation-tab/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* NAVIGATION_TABS */ "A"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(27), __webpack_require__.e(130)]).then(__webpack_require__.bind(null, "LNeH"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("LNeH")];
    },
    modules: ["./navigation-tabs/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFERS_GRID */ "B"], function () {
  return next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(153)]).then(__webpack_require__.bind(null, "wqTy"));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/("wqTy")];
      },
      modules: ["./offers-grid/descriptor"]
    }
  });
}], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFERS_PUSH */ "C"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(29), __webpack_require__.e(163)]).then(__webpack_require__.bind(null, "A3qt"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("A3qt")];
    },
    modules: ["./offers-push/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PREBOOKING_FORM */ "H"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(137)]).then(__webpack_require__.bind(null, "1w3z"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("1w3z")];
    },
    modules: ["./prebooking-form/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_TAGS */ "U"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(149)]).then(__webpack_require__.bind(null, "KQqJ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("KQqJ")];
    },
    modules: ["./product-tags/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCTS_FILTERS */ "I"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(126)]).then(__webpack_require__.bind(null, "s++G"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("s++G")];
    },
    modules: ["./products-filters/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_GRID */ "hb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(125)]).then(__webpack_require__.bind(null, "bNOZ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("bNOZ")];
    },
    modules: ["./products-grid/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* SECTION */ "tb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 260).then(__webpack_require__.bind(null, "0BFP"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("0BFP")];
    },
    modules: ["./section/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* SECTIONS */ "ub"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(28), __webpack_require__.e(261)]).then(__webpack_require__.bind(null, "qsa7"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("qsa7")];
    },
    modules: ["./sections/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* SMART_FAQ */ "vb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 263).then(__webpack_require__.bind(null, "+2Bl"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("+2Bl")];
    },
    modules: ["./smart-faq/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* SUBMISSION_STATUS */ "wb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(178)]).then(__webpack_require__.bind(null, "FQba"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("FQba")];
    },
    modules: ["./submission-status/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TAB */ "xb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 264).then(__webpack_require__.bind(null, "mM3U"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("mM3U")];
    },
    modules: ["./tab/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TABS */ "yb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(27), __webpack_require__.e(164)]).then(__webpack_require__.bind(null, "B07w"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("B07w")];
    },
    modules: ["./tabs/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TEASER_CARDS */ "zb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(143)]).then(__webpack_require__.bind(null, "6DS4"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("6DS4")];
    },
    modules: ["./teaser-cards/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TEST_AB */ "Ab"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 175).then(__webpack_require__.bind(null, "O94t"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("O94t")];
    },
    modules: ["./test-ab/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TEXT */ "Bb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(266)]).then(__webpack_require__.bind(null, "dJAn"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("dJAn")];
    },
    modules: ["./text/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* THEMATIC */ "Cb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(29), __webpack_require__.e(195)]).then(__webpack_require__.bind(null, "TgTY"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("TgTY")];
    },
    modules: ["./thematic/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TITLE_AND_TEXT */ "Db"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(172)]).then(__webpack_require__.bind(null, "aMVx"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("aMVx")];
    },
    modules: ["./title-and-text/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TRAVEL_RESTRICTIONS */ "Hb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(165)]).then(__webpack_require__.bind(null, "T5EZ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("T5EZ")];
    },
    modules: ["./travel-restrictions/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TRIPADVISOR_TESTIMONY */ "Ib"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(29), __webpack_require__.e(196)]).then(__webpack_require__.bind(null, "GSMs"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("GSMs")];
    },
    modules: ["./tripadvisor-testimony/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* VIDEO */ "Jb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(179)]).then(__webpack_require__.bind(null, "K7yN"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("K7yN")];
    },
    modules: ["./video/descriptor"]
  }
})],
/* home lines : homepage recommended */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* HIGHLIGHT */ "r"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(15), __webpack_require__.e(210)]).then(__webpack_require__.bind(null, "+nt3"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("+nt3")];
    },
    modules: ["./highlight/descriptor"]
  }
})],
/* offer lines : offerId needed */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFER_DESCRIPTION */ "D"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(171)]).then(__webpack_require__.bind(null, "wq1+"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("wq1+")];
    },
    modules: ["./offer-description/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFER_LEGAL_INFORMATION */ "E"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(188)]).then(__webpack_require__.bind(null, "Z6pd"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Z6pd")];
    },
    modules: ["./offer-legal-information/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFER_SEO */ "F"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 218).then(__webpack_require__.bind(null, "7YIZ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("7YIZ")];
    },
    modules: ["./offer-seo/descriptor"]
  }
})],
/* cruise lines : resortId/productId needed (only cruise ID) */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* CRUISE_BOOKING */ "h"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(16), __webpack_require__.e(128)]).then(__webpack_require__.bind(null, "oD44"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("oD44")];
    },
    modules: ["./cruise-booking/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* CRUISE_PROGRAM */ "i"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(202)]).then(__webpack_require__.bind(null, "NTfX"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("NTfX")];
    },
    modules: ["./cruise-program/descriptor"]
  }
})], // no ID needed but commonly on cruise page

/* product lines : resortId/productId needed */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* EXCLUSIVE_COLLECTION_SPACE */ "o"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(187)]).then(__webpack_require__.bind(null, "26Xc"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("26Xc")];
    },
    modules: ["./exclusive-collection-space/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* EXCLUSIVE_COLLECTION_SPACE_INTRODUCTION */ "p"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(186)]).then(__webpack_require__.bind(null, "eiEl"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("eiEl")];
    },
    modules: ["./exclusive-collection-space-introduction/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* HAPPY_TO_CARE */ "q"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(208)]).then(__webpack_require__.bind(null, "JxsF"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("JxsF")];
    },
    modules: ["./happy-to-care/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_ACCESS_AND_MAP */ "Z"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(189)]).then(__webpack_require__.bind(null, "Je/+"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Je/+")];
    },
    modules: ["./product-access-and-map/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_ACCOMMODATION_TYPES */ "bb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(140)]).then(__webpack_require__.bind(null, "m1uF"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("m1uF")];
    },
    modules: ["./product-accommodations/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION */ "ab"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(139)]).then(__webpack_require__.bind(null, "Kbtl"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Kbtl")];
    },
    modules: ["./product-accommodations-exclusive/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_ACTIVITIES */ "J"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(127)]).then(__webpack_require__.bind(null, "GSnJ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("GSnJ")];
    },
    modules: ["./product-activities/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_BARS */ "cb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(224)]).then(__webpack_require__.bind(null, "TFik"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("TFik")];
    },
    modules: ["./product-bars/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_BOOKING_BE */ "db"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(124)]).then(__webpack_require__.bind(null, "EgjI"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("EgjI")];
    },
    modules: ["./product-booking/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_BREADCRUMB */ "K"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(227)]).then(__webpack_require__.bind(null, "gfEP"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("gfEP")];
    },
    modules: ["./product-breadcrumb/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_CHILDCARES */ "L"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(141)]).then(__webpack_require__.bind(null, "uvus"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("uvus")];
    },
    modules: ["./product-childcares/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_DESTINATION */ "eb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(27), __webpack_require__.e(156)]).then(__webpack_require__.bind(null, "Smcz"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Smcz")];
    },
    modules: ["./product-destination/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_DISTRICT */ "fb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(135)]).then(__webpack_require__.bind(null, "YkGc"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("YkGc")];
    },
    modules: ["./resort-district/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_FLASH_INFO */ "gb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(160)]).then(__webpack_require__.bind(null, "1Ak6"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("1Ak6")];
    },
    modules: ["./product-flash-info/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_STREET_VIEW */ "S"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(231)]).then(__webpack_require__.bind(null, "yWVM"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("yWVM")];
    },
    modules: ["./product-google-street-view/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_IMAGE_MAP */ "M"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(192)]).then(__webpack_require__.bind(null, "YY1v"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("YY1v")];
    },
    modules: ["./product-image-map/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_IMMERSIVE */ "N"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(152)]).then(__webpack_require__.bind(null, "Nn0M"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Nn0M")];
    },
    modules: ["./product-immersive/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_INFORMATION_SUMMARY */ "O"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(193)]).then(__webpack_require__.bind(null, "PeCK"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("PeCK")];
    },
    modules: ["./product-information-summary/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_INTRODUCTION */ "ib"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(43), __webpack_require__.e(157)]).then(__webpack_require__.bind(null, "3cys"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("3cys")];
    },
    modules: ["./product-introduction/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_MEETING_ROOM_INFO */ "jb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(237)]).then(__webpack_require__.bind(null, "DnnJ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("DnnJ")];
    },
    modules: ["./product-meeting-room-info/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_MULTIMEDIA */ "kb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(161)]).then(__webpack_require__.bind(null, "mxuP"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("mxuP")];
    },
    modules: ["./product-multimedia/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* MUST_TRY_EXPERIENCES */ "y"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(177)]).then(__webpack_require__.bind(null, "wvxA"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("wvxA")];
    },
    modules: ["./product-must-try-experiences/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_PRICE_REMOTE */ "lb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(122)]).then(__webpack_require__.bind(null, "FLWE"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("FLWE")];
    },
    modules: ["./product-price-remote/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_PRICE_TICKET */ "mb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(183)]).then(__webpack_require__.bind(null, "eGWY"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("eGWY")];
    },
    modules: ["./product-price-ticket/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_PRICE_TICKET_CUSTOM */ "P"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(182)]).then(__webpack_require__.bind(null, "S5GU"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("S5GU")];
    },
    modules: ["./product-price-ticket-custom/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* QRCODE_PRODUCT_DRESSCODE */ "V"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(27), __webpack_require__.e(150)]).then(__webpack_require__.bind(null, "zyV9"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("zyV9")];
    },
    modules: ["./qrcode-product-dresscode/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* QRCODE_PRODUCT_PROGRAM */ "W"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(27), __webpack_require__.e(151)]).then(__webpack_require__.bind(null, "vLcP"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("vLcP")];
    },
    modules: ["./qrcode-product-program/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* QUOTATION_FORM */ "X"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(133)]).then(__webpack_require__.bind(null, "bpGR"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("bpGR")];
    },
    modules: ["./product-quotation-form/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_RECOMMENDATIONS */ "nb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(148)]).then(__webpack_require__.bind(null, "qmxF"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("qmxF")];
    },
    modules: ["./product-recommendations/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RELATED_PRODUCTS */ "Y"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(145)]).then(__webpack_require__.bind(null, "CSWM"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("CSWM")];
    },
    modules: ["./product-related-products/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_RESTAURANTS */ "ob"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(247)]).then(__webpack_require__.bind(null, "08wu"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("08wu")];
    },
    modules: ["./product-restaurants/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_SEO */ "pb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 249).then(__webpack_require__.bind(null, "CS9y"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("CS9y")];
    },
    modules: ["./product-seo-title/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_SERVICES */ "Q"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(167)]).then(__webpack_require__.bind(null, "Z4cC"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Z4cC")];
    },
    modules: ["./product-services/descriptor"]
  }
})], // no ID but commonly on product page
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_SIGNATURES */ "R"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(252)]).then(__webpack_require__.bind(null, "flGr"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("flGr")];
    },
    modules: ["./product-signatures/descriptor"]
  }
})], // no ID but commonly on product page
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_STRENGTHS */ "T"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(253)]).then(__webpack_require__.bind(null, "0a2G"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("0a2G")];
    },
    modules: ["./product-strengths/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_SUMMARY */ "qb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(146)]).then(__webpack_require__.bind(null, "/rmy"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("/rmy")];
    },
    modules: ["./product-summary/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_TRIPADVISOR */ "sb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(10), __webpack_require__.e(168)]).then(__webpack_require__.bind(null, "G5yF"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("G5yF")];
    },
    modules: ["./product-tripadvisor/descriptor"]
  }
})],
/* tour lines : resortId/productId needed (only tour ID) */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* TOUR_INTRODUCTION */ "Eb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(269)]).then(__webpack_require__.bind(null, "LQjd"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("LQjd")];
    },
    modules: ["./tour-introduction/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TOUR_PRACTICAL_INFORMATION */ "Fb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(271)]).then(__webpack_require__.bind(null, "9xag"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("9xag")];
    },
    modules: ["./tour-practical-information/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TOUR_PROGRAM */ "Gb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(273)]).then(__webpack_require__.bind(null, "cKQV"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("cKQV")];
    },
    modules: ["./tour-program/descriptor"]
  }
})]]);
var hasComponent = function hasComponent(name) {
  return descriptors.has(name);
};
var getComponent = function getComponent(name) {
  if (!descriptors.has(name)) {
    return null;
  }

  return descriptors.get(name);
};

/***/ }),

/***/ "oG87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorBoundary; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("aPQG");
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("igjW");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var ErrorBoundaryComponent = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(ErrorBoundaryComponent, _React$Component);

  var _super = _createSuper(ErrorBoundaryComponent);

  function ErrorBoundaryComponent(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, ErrorBoundaryComponent);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(ErrorBoundaryComponent, [{
    key: "componentDidCatch",
    // eslint-disable-next-line class-methods-use-this
    value: function componentDidCatch(error, info) {
      Object(_errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_12__[/* handleComponentError */ "a"])(error, info);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          router = _this$props.router,
          children = _this$props.children;

      if (this.state.hasError) {
        if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_13__[/* isStrictlyProductionEnv */ "f"])()) {
          var locale = router.query.locale;
          router.replace({
            pathname: '/500',
            query: Boolean(locale) && {
              locale: locale
            }
          });
        }

        return null;
      }

      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundaryComponent;
}(react__WEBPACK_IMPORTED_MODULE_10___default.a.Component);

var ErrorBoundary = Object(next_router__WEBPACK_IMPORTED_MODULE_11__["withRouter"])(ErrorBoundaryComponent);

/***/ }),

/***/ "pWxA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),

/***/ "sRHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _getPrototypeOf; });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "tCJK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Sections_Sections; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// CONCATENATED MODULE: ./src/client/components/frameworks/intersection-observer/createIntersectionObserver.js
if (true) {
  // Polyfills for intersection-observer
  __webpack_require__("LNcM");
}

function createIntersectionObserver(callback, options) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
  return new IntersectionObserver(callback, options);
}
// CONCATENATED MODULE: ./src/client/components/frameworks/intersection-observer/IntersectionObserver.jsx













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var IntersectionObserver_IntersectionObserver = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(IntersectionObserver, _Component);

  var _super = _createSuper(IntersectionObserver);

  function IntersectionObserver() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, IntersectionObserver);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleIntersection", function (_ref) {
      var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 1),
          entry = _ref2[0];

      _this.props.onChange(entry);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "observe", function () {
      if (_this.target && _this.observer) {
        _this.observer.observe(_this.target);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "unobserve", function () {
      if (_this.target && _this.observer) {
        _this.observer.unobserve(_this.target);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setRefTarget", function (target) {
      _this.targetChanged = _this.previousTarget && _this.previousTarget !== target;

      if (_this.targetChanged) {
        _this.unobserve();
      }

      _this.target = target;
    });

    return _this;
  }

  Object(createClass["a" /* default */])(IntersectionObserver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          rootMargin = _this$props.rootMargin,
          threshold = _this$props.threshold;
      this.observer = createIntersectionObserver(this.handleIntersection, {
        rootMargin: rootMargin,
        threshold: threshold
      });
      this.observe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unobserve();

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      // @todo remove this
      this.previousTarget = this.target;
      return /*#__PURE__*/react_default.a.cloneElement(react_default.a.Children.only(this.props.children), {
        ref: this.setRefTarget
      });
    }
  }]);

  return IntersectionObserver;
}(react["Component"]);

Object(defineProperty["a" /* default */])(IntersectionObserver_IntersectionObserver, "displayName", 'IntersectionObserver');

Object(defineProperty["a" /* default */])(IntersectionObserver_IntersectionObserver, "defaultProps", {
  rootMargin: '0px',
  threshold: 0
});
// CONCATENATED MODULE: ./src/client/components/frameworks/section/Section.jsx











var __jsx = react_default.a.createElement;

function Section_createSuper(Derived) { var hasNativeReflectConstruct = Section_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Section_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var Section_Section = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(Section, _PureComponent);

  var _super = Section_createSuper(Section);

  function Section(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Section);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "intersectionObserverThreshold", void 0);

    _this.intersectionObserverThreshold = [];

    for (var i = 0; i <= 1.0; i += 0.01) {
      // Get notified of every percent of visiblity change in the viewport (1% of intersection to 100%)
      _this.intersectionObserverThreshold.push(Math.round(i * 100) / 100);
    }

    return _this;
  }

  Object(createClass["a" /* default */])(Section, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          index = _this$props.index,
          name = _this$props.name;
      var anchor = name ? dist["url"].normalizeSlug(name) : null;
      return __jsx(IntersectionObserver_IntersectionObserver, {
        onChange: this.props.onSectionIntersectViewport,
        threshold: this.intersectionObserverThreshold
      }, __jsx("section", {
        className: className,
        "data-cs-override-id": "Section",
        "data-index": index,
        "data-testid": "section",
        id: anchor || null
      }, children));
    }
  }]);

  return Section;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(Section_Section, "defaultProps", {
  name: ''
});
// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/nav-tag/NavTag.jsx + 1 modules
var NavTag = __webpack_require__("UXOF");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// CONCATENATED MODULE: ./src/client/components/frameworks/sections/Sections.jsx





var Sections_jsx = react_default.a.createElement;








var Sections_Sections = function Sections(_ref) {
  var children = _ref.children,
      className = _ref.className,
      navItems = _ref.navItems,
      getTrackingData = _ref.getTrackingData,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      scrollForwardLabel = _ref.scrollForwardLabel,
      pageType = _ref.pageType;
  var track = Object(useTracking["a" /* useTracking */])();
  var navBarRef = Object(react["useRef"])(null);
  var onSectionIntersectViewport = Object(react["useRef"])(noop_default.a);

  var _useState = Object(react["useState"])(0),
      selectedIndex = _useState[0],
      setSelectedIndex = _useState[1];

  var navSelector = pageType || 'Sections'; // eslint-disable-next-line no-unused-vars

  var _useState2 = Object(react["useState"])(false),
      isSticky = _useState2[0],
      setIsSticky = _useState2[1];

  var onNavItemClick = Object(react["useCallback"])(function (anchor, index, label) {
    return function (e) {
      e.preventDefault(); // $FlowFixMe

      var selected = Number(index);
      var scrollRootOffsetSelector = "#".concat(navSelector);

      if (getTrackingData) {
        track(getTrackingData(label));
      }

      Object(scrollToElement["a" /* scrollToElement */])("#".concat(anchor), 600, scrollRootOffsetSelector).then(function () {
        setSelectedIndex(selected);
      });
    };
  }, []);
  var navbarItems = Object(react["useMemo"])(function () {
    return navItems.map(function (label, index) {
      var anchor = label ? dist["url"].normalizeSlug(label) : '';
      return {
        href: "#".concat(anchor),
        label: label,
        onClick: anchor ? onNavItemClick(anchor, index, label) : noop_default.a
      };
    });
  }, [navItems]);
  Object(react["useEffect"])(function () {
    if (!isSticky) {
      setSelectedIndex(0);
    }
  }, [isSticky]);
  Object(react["useEffect"])(function () {
    onSectionIntersectViewport.current = function (event) {
      var visiblePercentage = Math.floor(event.intersectionRatio * 100);

      var navBarHeight = navBarRef && get_default()(navBarRef, 'current.offsetHeight');

      var selected = Number(event.target.dataset.index);

      if (event.isIntersecting && visiblePercentage > 10 && event.intersectionRect.top <= navBarHeight) {
        setSelectedIndex(selected);
      }
    };
  }, []);
  Object(react["useEffect"])(function () {
    var element = navBarRef.current;
    var observer = new IntersectionObserver(function (_ref2) {
      var _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 1),
          e = _ref3[0];

      return setIsSticky(e.intersectionRatio < 1);
    }, {
      threshold: [1]
    });

    if (element) {
      observer.observe(element);
      return function () {
        return observer.unobserve(element);
      };
    }
  }, [navBarRef]);
  return Sections_jsx("div", {
    className: className
  }, Sections_jsx("div", {
    ref: navBarRef,
    id: navSelector,
    className: classnames_default()('flex bg-white sticky z-4 flex-wrap w-full mx-auto -top-1', {
      'border-b-1': isSticky
    })
  }, Sections_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: scrollBackwardLabel,
    childrenWrapperClassNames: "flex gap-10",
    className: "max-w-site py-10 bg-white lg:mx-auto w-full",
    forceDisplayControls: true,
    forwardLabel: scrollForwardLabel
  }, navbarItems.map(function (item, index) {
    return Sections_jsx(NavTag["a" /* NavTag */], {
      href: item.href,
      isActive: index === selectedIndex,
      key: item.label,
      onClick: item.onClick
    }, item.label);
  }))), react["Children"].map(children, function (section, index) {
    return Sections_jsx(Section_Section, {
      index: index,
      key: navItems[index],
      name: navItems[index],
      onSectionIntersectViewport: onSectionIntersectViewport.current
    }, section);
  }));
};
Sections_Sections.defaultProps = {
  children: [],
  navItems: [],
  pageType: ''
};

/***/ }),

/***/ "uLWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: Grid

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.jsx
var Responsive = __webpack_require__("Gqxm");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// CONCATENATED MODULE: ./src/client/components/frameworks/more-results/MoreResults.jsx

var __jsx = react_default.a.createElement;




var MoreResults_MoreResults = function MoreResults(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      _ref$number = _ref.number,
      number = _ref$number === void 0 ? 0 : _ref$number,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop_default.a : _ref$onClick,
      text = _ref.text;

  if (!number) {
    return null;
  }

  return __jsx("div", {
    className: classnames_default()(className, 'flex justify-center w-full')
  }, __jsx(Button["a" /* Button */], {
    color: colors["a" /* COLORS */].SIENNA,
    colorBg: colors["a" /* COLORS */].TRANSPARENT,
    colorBorder: colors["a" /* COLORS */].SIENNA,
    dataTestId: "more-results-btn",
    isLoading: isLoading,
    onClick: onClick,
    size: "medium"
  }, __jsx("span", {
    "data-testid": "Moreresults-number"
  }, number), " ", text));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/grid/Grid.jsx
















var Grid_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable clubmed/no-fake-component */





function getWidth() {
  var fraction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return fraction < 2 || fraction > 4 ? 'grid-cols-1' : "grid-cols-".concat(fraction);
}

function filterContext(hasOneRemaining, itemsByLine, isSeeMoreVisible) {
  return function (item, index) {
    if (isSeeMoreVisible) {
      return index < itemsByLine;
    }

    return true;
  };
}

var Grid_Grid = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Grid, _Component);

  var _super = _createSuper(Grid);

  function Grid() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Grid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      isExpanded: !_this.props.hasSeeMore
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickSeeMore", function () {
      var _this$props = _this.props,
          _this$props$totalNumb = _this$props.totalNumberToDisplay,
          totalNumberToDisplay = _this$props$totalNumb === void 0 ? 0 : _this$props$totalNumb,
          _this$props$getChildr = _this$props.getChildren,
          getChildren = _this$props$getChildr === void 0 ? function () {
        return Promise.resolve({});
      } : _this$props$getChildr,
          _this$props$isSynchro = _this$props.isSynchronousGrid,
          isSynchronousGrid = _this$props$isSynchro === void 0 ? false : _this$props$isSynchro;

      if (isSynchronousGrid || totalNumberToDisplay === _this.getItemsByLine()) {
        _this.setState({
          isExpanded: true
        });
      }

      if (totalNumberToDisplay > _this.getItemsByLine()) {
        getChildren();
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Grid, [{
    key: "getGrid",
    value: function getGrid() {
      var _this$props$grid = this.props.grid,
          grid = _this$props$grid === void 0 ? {} : _this$props$grid;
      var desktop = grid.desktop,
          tablet = grid.tablet,
          phablet = grid.phablet,
          mobile = grid.mobile;
      return "".concat(getWidth(mobile), " sm:").concat(getWidth(phablet), " md:").concat(getWidth(tablet), " lg:").concat(getWidth(desktop));
    }
  }, {
    key: "getItemsByLine",
    value: function getItemsByLine() {
      var _this$props2 = this.props,
          _this$props2$display = _this$props2.display,
          display = _this$props2$display === void 0 ? {} : _this$props2$display,
          _this$props2$responsi = _this$props2.responsive,
          responsive = _this$props2$responsi === void 0 ? {} : _this$props2$responsi;
      var _display$desktop = display.desktop,
          desktop = _display$desktop === void 0 ? 1 : _display$desktop,
          _display$tablet = display.tablet,
          tablet = _display$tablet === void 0 ? 1 : _display$tablet,
          _display$phablet = display.phablet,
          phablet = _display$phablet === void 0 ? 1 : _display$phablet,
          _display$mobile = display.mobile,
          mobile = _display$mobile === void 0 ? 1 : _display$mobile;
      var _responsive$isBrowser = responsive.isBrowserGreaterThan,
          isBrowserGreaterThan = _responsive$isBrowser === void 0 ? {} : _responsive$isBrowser;

      if (isBrowserGreaterThan.M && desktop > -1) {
        return desktop;
      }

      if (isBrowserGreaterThan.S && tablet > -1) {
        return tablet;
      }

      if (isBrowserGreaterThan.XS && phablet > -1) {
        return phablet;
      }

      return mobile;
    }
  }, {
    key: "getNumberOfItemsByLineExcludingSeeMore",
    value: function getNumberOfItemsByLineExcludingSeeMore() {
      return this.getItemsByLine();
    }
  }, {
    key: "getRest",
    value: function getRest() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          totalNumberToDisplay = _this$props3.totalNumberToDisplay;
      return totalNumberToDisplay ? totalNumberToDisplay - this.getItemsByLine() : react["Children"].count(children) - this.getItemsByLine();
    }
  }, {
    key: "getSeeMore",
    value: function getSeeMore() {
      var _this$props4 = this.props,
          hasSeeMore = _this$props4.hasSeeMore,
          isLoading = _this$props4.isLoading,
          seeMore = _this$props4.seeMore;
      return hasSeeMore && this.getRest() > 0 && !this.state.isExpanded ? Grid_jsx(MoreResults_MoreResults, Object(esm_extends["a" /* default */])({}, seeMore, {
        className: "mt-20",
        isLoading: isLoading,
        number: this.getRest(),
        onClick: this.onClickSeeMore
      })) : null;
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this2 = this;

      var hasOneRemaining = this.getRest() === 1;
      var filterItem = filterContext(hasOneRemaining, this.getNumberOfItemsByLineExcludingSeeMore(), !this.state.isExpanded);
      return react["Children"].toArray(this.props.children).filter(filterItem).map(function (item) {
        return Grid_jsx("div", {
          className: classnames_default()('fadeIn', _this2.props.childrenClassName),
          "data-testid": "Grid-item",
          key: item.key
        }, item);
      });
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return Object(toConsumableArray["a" /* default */])(this.getChildren()).filter(function (i) {
        return i;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var isLoading = _ref.isLoading;

      if (isLoading && !this.props.isLoading && !this.state.isExpanded) {
        this.setState({
          isExpanded: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var items = this.getItems();
      return items.length ? Grid_jsx(react["Fragment"], null, Grid_jsx("div", {
        className: classnames_default()(className, 'gap-20 grid relative', this.getGrid()),
        "data-testid": "grid"
      }, items.map(function (item, index) {
        return (
          /* eslint-disable react/no-array-index-key */
          Grid_jsx(react["Fragment"], {
            key: index
          }, item)
        );
      })), this.getSeeMore()) : null;
    }
  }]);

  return Grid;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Grid_Grid, "defaultProps", {
  display: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  },
  getChildren: function getChildren() {
    return Promise.resolve({});
  },
  grid: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  }
});

/* harmony default export */ var grid_Grid = __webpack_exports__["a"] = (Object(Responsive["a" /* default */])(Grid_Grid));

/***/ }),

/***/ "wNDy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ NotFoundError; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ BadRequest; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ ClientSideError; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ ProposalNotFound; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ errors_ApiException; });

// UNUSED EXPORTS: CmsConfigError, RequestFailed, GraphqlError, OfferNotFound, ZoneNotFound, LandingNotFound, ResortNotFound, PriceNotFound, PageNotFound

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__("XcBm");

// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/construct.js


function construct_construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    construct_construct = Reflect.construct.bind();
  } else {
    construct_construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) Object(setPrototypeOf["a" /* default */])(instance, Class.prototype);
      return instance;
    };
  }
  return construct_construct.apply(null, arguments);
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function wrapNativeSuper_wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  wrapNativeSuper_wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return construct_construct(Class, arguments, Object(getPrototypeOf["a" /* default */])(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return Object(setPrototypeOf["a" /* default */])(Wrapper, Class);
  };
  return wrapNativeSuper_wrapNativeSuper(Class);
}
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/error.js/index.js
var error_js = __webpack_require__("x5Ag");
var error_js_default = /*#__PURE__*/__webpack_require__.n(error_js);

// CONCATENATED MODULE: ./src/errors/errors.js












function _createSuper(Derived) {
  var hasNativeReflectConstruct = errors_isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(possibleConstructorReturn["a" /* default */])(this, result);
  };
}

function errors_isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}


var NotFoundError = error_js_default.a.create({
  name: 'NotFoundError',
  message: 'Content not found',
  statusCode: 404,
  redirect: '/404',
  logLevel: 'warn'
});
var BadRequest = error_js_default.a.create({
  name: 'BadRequest',
  message: 'Bad request',
  statusCode: 400,
  logLevel: 'error'
});
var CmsConfigError = error_js_default.a.create({
  name: 'CmsConfigError',
  message: 'Cms configuration error',
  statusCode: 500,
  logLevel: 'error'
});
var RequestFailed = error_js_default.a.create({
  name: 'RequestFailed',
  message: 'Request failed',
  statusCode: 500,
  logLevel: 'error'
});
var GraphqlError = error_js_default.a.create({
  name: 'GraphqlError',
  message: 'Graphql request failed',
  statusCode: 500,
  logLevel: 'error'
});
var ClientSideError = error_js_default.a.create({
  name: 'ClientSideError',
  message: 'Client side error',
  statusCode: 500,
  logLevel: 'error'
});
var OfferNotFound = error_js_default.a.create({
  name: 'OfferNotFound'
}, NotFoundError);
var ZoneNotFound = error_js_default.a.create({
  name: 'ZoneNotFound'
}, NotFoundError);
var LandingNotFound = error_js_default.a.create({
  name: 'LandingNotFound'
}, NotFoundError);
var ResortNotFound = error_js_default.a.create({
  name: 'ResortNotFound'
}, NotFoundError);
var PriceNotFound = error_js_default.a.create({
  name: 'PriceNotFound'
}, NotFoundError);
var ProposalNotFound = error_js_default.a.create({
  name: 'ProposalNotFound'
}, NotFoundError);
var PageNotFound = error_js_default.a.create({
  name: 'PageNotFound'
}, NotFoundError);
var errors_ApiException = /*#__PURE__*/function (_Error) {
  Object(inherits["a" /* default */])(ApiException, _Error);

  var _super = _createSuper(ApiException);

  function ApiException(errors) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ApiException);

    _this = _super.call.apply(_super, [this].concat(Object(toConsumableArray["a" /* default */])(errors)));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "apiErrors", void 0);

    _this.name = 'ApiException';
    _this.apiErrors = errors;
    return _this;
  }

  return ApiException;
}( /*#__PURE__*/wrapNativeSuper_wrapNativeSuper(Error));

/***/ }),

/***/ "ybtA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return Line; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _logger_logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("zytj");
/* harmony import */ var _context_ErrorBoundary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("oG87");
/* harmony import */ var _cms_toolkit_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nZ6J");





var __jsx = react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement;




var Line = function Line(_ref) {
  var dataTestIdPrefix = _ref.dataTestIdPrefix,
      id = _ref.id,
      name = _ref.name,
      component = _ref.component,
      _ref$pageLines = _ref.pageLines,
      pageLines = _ref$pageLines === void 0 ? [] : _ref$pageLines,
      _ref$props = _ref.props,
      _ref$props$lines = _ref$props.lines,
      lines = _ref$props$lines === void 0 ? [] : _ref$props$lines,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_ref$props, ["lines"]);

  if (!component && !Object(_cms_toolkit_descriptors__WEBPACK_IMPORTED_MODULE_8__[/* hasComponent */ "b"])(name) && lines.length === 0) {
    _logger_logger__WEBPACK_IMPORTED_MODULE_6__["default"].warn("Line without Component ".concat(String(id), " / ").concat(String(name)));
    return null;
  }

  var Component = component || Object(_cms_toolkit_descriptors__WEBPACK_IMPORTED_MODULE_8__[/* getComponent */ "a"])(name);

  if (Component) {
    return __jsx(_context_ErrorBoundary__WEBPACK_IMPORTED_MODULE_7__[/* ErrorBoundary */ "a"], {
      key: id
    }, __jsx(Component, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, props, {
      dataTestIdPrefix: dataTestIdPrefix,
      lines: lines,
      pageLines: pageLines
    }), lines.map(function (line) {
      return __jsx(Line, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, line, {
        dataTestIdPrefix: dataTestIdPrefix,
        key: line.id,
        pageLines: pageLines
      }));
    })));
  }

  return __jsx(_context_ErrorBoundary__WEBPACK_IMPORTED_MODULE_7__[/* ErrorBoundary */ "a"], {
    key: id
  }, lines.map(function (line) {
    return __jsx(Line, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, line, {
      dataTestIdPrefix: dataTestIdPrefix,
      key: line.id,
      pageLines: pageLines
    }));
  }));
};

/***/ }),

/***/ "yfdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductPriceModal_ProductPriceModal; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.utils.js

var ProductPriceModal_utils_getLabel = function getLabel(_ref) {
  var isJoyview = _ref.isJoyview,
      isTour = _ref.isTour;

  if (isTour) {
    return '';
  }

  return isJoyview ? Object(i18n["h" /* t */])('resort.startingPrice.roomOnly') : Object(i18n["h" /* t */])('resort.startingPrice.allInclusive');
};
// EXTERNAL MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx + 1 modules
var PopOver = __webpack_require__("Xzib");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx
var __jsx = react_default.a.createElement;




var ProductPriceModal_ProductPriceModal = function ProductPriceModal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      city = _ref.city,
      endDate = _ref.endDate,
      _ref$hasTransport = _ref.hasTransport,
      hasTransport = _ref$hasTransport === void 0 ? false : _ref$hasTransport,
      _ref$isCruise = _ref.isCruise,
      isCruise = _ref$isCruise === void 0 ? false : _ref$isCruise,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      _ref$isTour = _ref.isTour,
      isTour = _ref$isTour === void 0 ? false : _ref$isTour,
      onClick = _ref.onClick,
      onClickButton = _ref.onClickButton,
      rate = _ref.rate,
      startDate = _ref.startDate,
      unit = _ref.unit;

  if (!react["Children"].count(children)) {
    return null;
  }

  return __jsx(PopOver["a" /* PopOver */], {
    ariaLabel: ProductPriceModal_utils_getLabel({
      isJoyview: isJoyview,
      isTour: isTour
    }),
    className: className,
    content: __jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
      city: city,
      endDate: endDate,
      hasTransport: hasTransport,
      isCruise: isCruise,
      isJoyview: isJoyview,
      isTour: isTour,
      onClick: onClickButton,
      rate: rate,
      startDate: startDate,
      unit: unit
    }),
    isModalOnly: true,
    onClick: onClick
  }, children);
};

/***/ })

}]);